import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {ConstantsService} from '../../fidelidade/ConstantsService';
import {AutorizacaoService} from '../../services/autorizacao.service';
import {RotaGuardClient} from '../../guards/auth-loja.guard';
import {NotificationService} from '../../services/notification.service';
import {ImportadorIfoodService} from '../../services/importador-ifood.service';
import {CanaisVendaFacade, ErroHttpCanalVenda} from '../canais-venda.facade';
import {MesclagemProdutoCanalVendaComponent} from '../mesclagem-produto-canal-venda.component';
import {
  areasAlteradasRevisao, gruposRevisao, GrupoRevisaoCanalVenda, imagemRevisao,
  linhasRevisao, LinhaRevisaoCanalVenda
} from '../canais-venda.revisao';
import {
  AlteracaoCompartilhadaCanalVendaVM,
  CanalVendaVM,
  LimpezaFood99VM,
  ComparacaoAtualIfoodVM, ResolucaoAdicionalIfoodVM,
  CategoriaExternaCanalVendaVM,
  ConfiguracaoProdutoCanalVenda,
  DestinoCanalVendaVM,
  DestinosCanalVendaVM,
  HistoricoProdutoCanalVendaVM,
  ItemPublicacaoCanalVendaVM,
  PaginaCatalogoCanalVendaVM,
  PendenciaComparacaoIfoodVM,
  PrecoConfirmacaoCanalVendaVM,
  PreviaCanalVendaVM,
  PreviaProdutoCanalVendaVM,
  ProdutoCatalogoCanalVendaVM,
  ProdutoCatalogoExternoVinculacaoVM,
  PreviaVinculacaoProdutoCanalVendaVM,
  PublicacaoCanalVendaVM,
  ResumoPublicacaoCanalVendaVM,
  ResultadoVinculacaoProdutoIfoodVM,
  CorrespondenciasVinculacaoProdutoCanalVendaVM,
  PreviaMesclagemVinculacaoVM
} from '../canais-venda.models';
import {
  altereSelecaoPagina,
  produtoPodeSerSelecionadoParaPublicacao,
  rotuloCaminhoDiferenca,
  selecaoDaPaginaCompleta
} from '../canais-venda.logic';

type ModoTelaCanalVenda = 'INICIAL' | 'ALTERACOES';
type AbaAlteracoesCanalVenda = 'PENDENTES' | 'PROCESSANDO';
type FiltroCatalogoCanalVenda = 'PUBLICADOS' | 'NOVOS' | 'ALTERACOES' | 'ATUALIZADOS';

interface EdicaoProdutoCanalVenda {
  disponivel: boolean;
  salvando: boolean;
}

type ProdutoExternoVinculacao = Pick<ProdutoCatalogoExternoVinculacaoVM,
  'nome' | 'codigoPdv' | 'categoria' | 'imagem'> & {preco: number | null};

@Component({
  selector: 'app-tela-canais-venda',
  templateUrl: './tela-canais-venda.component.html',
  styleUrls: ['./tela-canais-venda.component.scss']
})
export class TelaCanaisVendaComponent implements OnInit, OnDestroy {
  limpezaFood99: LimpezaFood99VM | null = null;
  modalLimpezaFood99 = false;
  carregandoLimpezaFood99 = false;
  erroLimpezaFood99 = '';
  private canalLimpezaFood99: number | null = null;

  get administradorLimpezaFood99(): boolean {
    const usuario = this.autorizacaoService.getUser();
    return usuario?.admin === true || usuario?.superadmin === true;
  }

  async abraLimpezaFood99(): Promise<void> {
    if(!this.administradorLimpezaFood99 || this.canalSelecionado?.plataforma !== 'FOOD99') return;
    this.canalLimpezaFood99 = this.canalSelecionadoId;
    this.modalLimpezaFood99 = true;
    this.limpezaFood99 = null;
    await this.executeLimpezaFood99('previa');
  }

  fecheLimpezaFood99(): void {
    if(this.carregandoLimpezaFood99) return;
    this.modalLimpezaFood99 = false;
  }

  async executeLimpezaFood99(acao: 'previa' | 'confirmar' | 'consultar'): Promise<void> {
    if(this.carregandoLimpezaFood99 || !this.canalLimpezaFood99 || !this.administradorLimpezaFood99) return;
    if(acao === 'confirmar' && this.limpezaFood99?.situacao !== 'PREVIA') return;
    this.carregandoLimpezaFood99 = true;
    this.erroLimpezaFood99 = '';
    try {
      this.limpezaFood99 = await (acao === 'previa'
        ? this.facade.previaLimpezaFood99(this.canalLimpezaFood99)
        : acao === 'confirmar'
          ? this.facade.confirmeLimpezaFood99(this.canalLimpezaFood99, this.limpezaFood99.id)
          : this.facade.consulteLimpezaFood99(this.canalLimpezaFood99));
      if(this.limpezaFood99?.situacao === 'CONCLUIDO') {
        this.canais = await this.facade.listeCanais();
        if(this.destinos) this.destinos.canais = this.canais;
        if(this.canalSelecionadoId === this.canalLimpezaFood99) {
          this.filtroCatalogo = 'NOVOS';
          this.previaLote = null;
          this.revisaoAberta = false;
          this.publicacao = null;
          this.selecionados.clear();
          this.resumosPrevia = {};
          await this.carregueCatalogo();
        }
      } else if(this.limpezaFood99?.situacao !== 'PREVIA') {
        const canal = this.canais.find(item => item.id === this.canalLimpezaFood99);
        if(canal && ['ENVIANDO', 'AGUARDANDO', 'INCERTO'].includes(this.limpezaFood99?.situacao)) canal.ativo = false;
      }
    } catch(erro) {
      this.erroLimpezaFood99 = erro.message || 'Não foi possível concluir o reset local.';
    } finally {
      this.carregandoLimpezaFood99 = false;
    }
  }

  readonly ladosComparacaoIfood: Array<'antes' | 'depois'> = ['antes', 'depois'];
  comparacaoIfood: ComparacaoAtualIfoodVM | null = null;
  produtoComparacaoIfood: ProdutoCatalogoCanalVendaVM | null = null;
  camposComparacaoIfood: {[campo: string]: boolean} = {};
  mapeandoComparacaoIfood = false;
  categoriaComparacaoIfood = '';
  readonly totalCamposComparacaoIfood = 6;
  carregandoComparacaoIfood = false;
  salvandoComparacaoIfood = false;
  erroComparacaoIfood = '';
  pendenciasComparacaoIfood: PendenciaComparacaoIfoodVM[] = [];
  private geracaoComparacaoIfood = 0;
  @ViewChild('modalComparacaoIfood') modalComparacaoIfood?: ElementRef<HTMLElement>;
  private focoAnteriorComparacaoIfood: HTMLElement | null = null;

  modo: ModoTelaCanalVenda = 'INICIAL';
  aba: AbaAlteracoesCanalVenda = 'PENDENTES';
  filtroCatalogo: FiltroCatalogoCanalVenda = 'ALTERACOES';
  filtroDisponibilidade = 'TODAS';
  produtosCarregados: {[produtoId: number]: ProdutoCatalogoCanalVendaVM} = {};
  resumosPrevia: {[produtoId: number]: PreviaProdutoCanalVendaVM} = {};
  erroResumos = false;
  carregando = true;
  vinculandoExistentes = false;
  resultadoVinculacao: ResultadoVinculacaoProdutoIfoodVM | null = null;
  erroVinculacao = '';
  mostrarVinculacao = false;
  carregandoProdutosVinculacao = false;
  erroProdutosVinculacao = '';
  erroAnaliseVinculacao = '';
  paginaVinculacao: PaginaCatalogoCanalVendaVM | null = null;
  previaVinculacao: {[produtoId: number]: PreviaVinculacaoProdutoCanalVendaVM['itens'][number]} = {};
  catalogoExternoVinculacao: ProdutoCatalogoExternoVinculacaoVM[] = [];
  seletorProdutoIfoodAberto: number | null = null;
  produtosIfoodSelecionados: {[produtoId: number]: ProdutoCatalogoExternoVinculacaoVM} = {};
  ignoradosVinculacao = new Set<number>();
  produtoIfoodBusca = '';
  statusVinculacaoProdutos: {[produtoId: number]: {situacao: string; mensagem: string}} = {};
  carregandoAnaliseVinculacao = false;
  mesclagem: PreviaMesclagemVinculacaoVM | null = null;
  carregandoMesclagem = false;
  erroMesclagem = '';
  mesclagensRevisadas: {[produtoId: number]: {itemId: string; escolhas: CorrespondenciasVinculacaoProdutoCanalVendaVM}} = {};
  rascunhosVinculacao: {[produtoId: number]: CorrespondenciasVinculacaoProdutoCanalVendaVM} = {};
  produtoSelecionadoVinculacaoId: number | null = null;
  buscaProdutosVinculacao = '';
  categoriasVinculacaoRecolhidas = new Set<string>();
  private geracaoAnaliseProdutoVinculacao = 0;
  private geracaoListaVinculacao = 0;
  private geracaoPreviaVinculacao = 0;
  @ViewChild('modalVinculacao') modalVinculacao?: ElementRef<HTMLElement>;
  @ViewChild(MesclagemProdutoCanalVendaComponent) componenteMesclagem?: MesclagemProdutoCanalVendaComponent;
  private focoAnteriorVinculacao: HTMLElement | null = null;
  private consumindoVinculacaoUrl = false;
  private parametrosSubscription: Subscription;
  carregandoCatalogo = false;
  erro = '';
  avisoRuntime = '';
  destinos: DestinosCanalVendaVM | null = null;
  canais: CanalVendaVM[] = [];
  canalSelecionadoId: number | null = null;
  pagina: PaginaCatalogoCanalVendaVM | null = null;
  numeroPagina = 1;
  tamanhoPagina = 20;
  busca = '';
  confirmarDesativacao = false;
  confirmarRemocao = false;
  erroRemocaoCanal = '';
  @ViewChild('modalRemocaoCanal') modalRemocaoCanal?: ElementRef<HTMLElement>;
  private focoAnteriorRemocaoCanal: HTMLElement | null = null;
  desativandoCanal = false;
  imagensComErro = new Set<string>();
  categoriaId: number | null = null;
  categoriasCatalogo: Array<{id: number; nome: string}> = [];
  selecionados = new Set<number>();
  recursosSelecionados = new Set<number>();
  expandidos = new Set<number>();
  previas: {[produtoId: number]: PreviaProdutoCanalVendaVM} = {};
  carregandoPrevia = new Set<number>();
  edicoes: {[produtoId: number]: EdicaoProdutoCanalVenda} = {};
  previaLote: PreviaCanalVendaVM | null = null;
  revisaoAberta = false;
  erroRevisao = '';
  confirmarDescarte = false;
  descartandoPendencias = false;
  erroDescarte = '';
  recursosParaCancelar: Array<{recursoId: number; versao: number}> = [];
  @ViewChild('modalCancelamentoPendencias') modalCancelamentoPendencias?: ElementRef<HTMLElement>;
  private focoAnteriorCancelamentoPendencias: HTMLElement | null = null;
  detalhesRevisao = new Set<number>();
  gruposRevisaoRecolhidos = new Set<string>();
  abasRevisao: {[id: number]: 'PRODUTO' | 'IMAGEM' | 'ADICIONAIS'} = {};
  carregandoDetalhesRevisao = new Set<number>();
  errosDetalhesRevisao: {[id: number]: string} = {};
  comparacoesRevisao: {[id: number]: {
    completas: LinhaRevisaoCanalVenda[];
    grupos: GrupoRevisaoCanalVenda[]
  }} = {};
  revisaoDesatualizada = false;
  confirmacaoPrecosToken: string | null = null;
  precosRevisao: {[chave: string]: number | null} = {};
  precosRevisaoPorProduto: {[produtoId: number]: PrecoConfirmacaoCanalVendaVM[]} = {};
  precosRevisaoRecolhidos = new Set<number>();
  salvandoPrecosRevisao = false;
  areasAlteradasRevisao = areasAlteradasRevisao;
  publicando = false;
  reenviandoItemId: number | null = null;
  publicacao: PublicacaoCanalVendaVM | null = null;
  publicacaoId: number | null = null;
  atualizandoAndamento = false;
  ultimaConsultaAndamento: Date | null = null;
  resultadoConsultaAndamento = '';
  erroConsultaAndamento = false;
  publicacoes: ResumoPublicacaoCanalVendaVM[] = [];
  categoriasExternas: CategoriaExternaCanalVendaVM[] = [];
  categoriasExternasCarregando = false;
  categoriasExternasErro = '';
  categoriasExternasSelecionadas: {[categoriaLocalId: number]: string} = {};
  categoriasResolvendo = new Set<number>();
  historico: HistoricoProdutoCanalVendaVM | null = null;
  produtoHistorico: ProdutoCatalogoCanalVendaVM | null = null;
  carregandoHistorico = false;
  erroHistorico = '';
  @ViewChild('drawerHistorico') drawerHistorico?: ElementRef<HTMLElement>;
  private focoAnteriorHistorico: HTMLElement | null = null;
  private geracaoHistorico = 0;
  detalhesTecnicosPublicacao = new Set<number>();
  operacaoMassa = '';
  aplicandoMassa = false;
  mostrarNovoCanal = false;
  erroNovoCanal = '';
  @ViewChild('formularioNovoCanal') formularioNovoCanal?: ElementRef<HTMLElement>;
  private focoAnteriorNovoCanal: HTMLElement | null = null;
  destinoNovoCanalId: string | null = null;
  nomeNovoCanal = '';
  catalogoExternoNovoCanal = '';
  catalogosNovoCanal: Array<{id: string; nome: string}> = [];
  carregandoCatalogosNovoCanal = false;
  salvandoCanal = false;
  precoIgualNovoCanal = true;
  percentualNovoCanal: number | null = null;
  configurandoPrecoCanal = false;
  precoIgualCanal = true;
  percentualCanal: number | null = null;
  salvandoPrecoCanal = false;
  erroPrecoCanal = '';
  private buscaTimer: any = null;
  private pollTimer: any = null;
  private pollGeracao = 0;
  private pollQuantidade = 0;
  private geracaoCanal = 0;
  private geracaoCatalogo = 0;
  private geracaoContexto = 0;
  private geracaoPrevia = 0;
  private selecaoInicialAlteracoesAplicada = false;
  private selecaoAutomaticaAlteracoes = true;
  private requisicoesPrevia: {[produtoId: number]: number} = {};
  private destruido = false;
  private empresaSubscription: Subscription;
  private readonly limitePoll = 40;

  constructor(
    private facade: CanaisVendaFacade,
    private route: ActivatedRoute,
    private router: Router,
    private notificacao: NotificationService,
    private importadorIfood: ImportadorIfoodService,
    private constantsService: ConstantsService,
    private autorizacaoService: AutorizacaoService
  ) {}

  get podeGerenciarCanal(): boolean {
    return RotaGuardClient.gerenciaLoja(this.autorizacaoService.getUser());
  }

  ngOnInit(): void {
    this.modo = this.route.snapshot.data.modo === 'ALTERACOES' ? 'ALTERACOES' : 'INICIAL';
    this.aba = this.modo === 'ALTERACOES' ? 'PROCESSANDO' : 'PENDENTES';
    this.empresaSubscription = this.constantsService.empresa$.subscribe(empresa => {
      this.categoriasCatalogo = (empresa?.catalogo?.categorias || [])
        .map((categoria: any) => ({id: Number(categoria.id), nome: categoria.nome}));
      this.categoriasCatalogo.sort((a, b) => a.nome.localeCompare(b.nome));
    });
    void this.inicialize();
  }

  ngOnDestroy(): void {
    this.destruido = true;
    this.geracaoHistorico++;
    this.empresaSubscription?.unsubscribe();
    this.parametrosSubscription?.unsubscribe();
    this.cancelePoll();
    if(this.buscaTimer) clearTimeout(this.buscaTimer);
  }

  get canalSelecionado(): CanalVendaVM | null {
    return this.canais.find(canal => canal.id === Number(this.canalSelecionadoId)) || null;
  }

  get produtoSelecionadoVinculacao(): ProdutoCatalogoCanalVendaVM | null {
    return this.paginaVinculacao?.itens.find(produto => produto.produtoId === this.produtoSelecionadoVinculacaoId) || null;
  }

  get categoriasProdutosVinculacao(): Array<{chave: string; nome: string; produtos: ProdutoCatalogoCanalVendaVM[]}> {
    const busca = this.normalizeTextoBusca(this.buscaProdutosVinculacao);
    const categorias = new Map<string, {chave: string; nome: string; produtos: ProdutoCatalogoCanalVendaVM[]}>();
    for(const produto of this.paginaVinculacao?.itens || []) {
      const nome = produto.categoria?.nome || 'Sem categoria';
      if(busca && ![produto.nome, produto.codigoPdv, nome, produto.produtoId]
        .some(valor => this.normalizeTextoBusca(valor).includes(busca))) continue;
      const chave = produto.categoria?.id == null ? 'sem-categoria' : String(produto.categoria.id);
      if(!categorias.has(chave)) categorias.set(chave, {chave, nome, produtos: []});
      categorias.get(chave)!.produtos.push(produto);
    }
    return Array.from(categorias.values()).sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
  }

  categoriaVinculacaoRecolhida(chave: string): boolean {
    return !this.buscaProdutosVinculacao && this.categoriasVinculacaoRecolhidas.has(chave);
  }

  altereCategoriaVinculacao(chave: string): void {
    if(this.categoriasVinculacaoRecolhidas.has(chave)) this.categoriasVinculacaoRecolhidas.delete(chave);
    else this.categoriasVinculacaoRecolhidas.add(chave);
  }

  get quantidadeVinculadosCanal(): number {
    return Number(this.paginaVinculacao?.contadores?.vinculados || 0);
  }

  get quantidadeSemVinculoCanal(): number {
    return Number(this.paginaVinculacao?.contadores?.semVinculo || 0);
  }

  get idsVinculaveis(): number[] {
    return Object.keys(this.mesclagensRevisadas).map(Number).filter(produtoId =>
      !this.ignoradosVinculacao.has(produtoId) &&
      !['VINCULADO', 'JA_VINCULADO'].includes(this.statusVinculacaoProdutos[produtoId]?.situacao));
  }

  get quantidadeVinculaveis(): number {
    return this.idsVinculaveis.length;
  }

  previaDoProduto(produtoId: number): PreviaVinculacaoProdutoCanalVendaVM['itens'][number] | null {
    return this.previaVinculacao[Number(produtoId)] || null;
  }

  produtoAssociadoVinculacao(produtoId: number): boolean {
    return !!this.produtosIfoodSelecionados[produtoId] ||
      this.previaDoProduto(produtoId)?.situacao === 'ENCONTRADO';
  }

  produtoExternoVinculacao(produtoId: number): ProdutoExternoVinculacao | null {
    const selecionado = this.produtosIfoodSelecionados[produtoId];
    if(selecionado) return selecionado;
    const previa = this.previaDoProduto(produtoId);
    if(previa?.situacao !== 'ENCONTRADO') return null;
    const candidato = previa.produtosIfood[0];
    if(!candidato) return null;
    return this.catalogoExternoVinculacao.find(item =>
      item.itemId === candidato.itemId || item.id === candidato.id) ||
      {...candidato, imagem: null, preco: null};
  }

  categoriasVinculacaoDiferentes(local: ProdutoCatalogoCanalVendaVM, externo: ProdutoExternoVinculacao): boolean {
    return this.normalizeTextoBusca(local.categoria?.nome) !== this.normalizeTextoBusca(externo.categoria?.nome);
  }

  rotuloProdutoVinculacao(produtoId: number): string {
    const situacao = this.statusVinculacaoProdutos[produtoId]?.situacao;
    if(situacao === 'VINCULADO' || situacao === 'JA_VINCULADO') return 'Vinculado';
    if(situacao === 'FALHA') return 'Erro';
    if(this.ignoradosVinculacao.has(produtoId)) return 'Ignorado';
    if(this.mesclagensRevisadas[produtoId]) return 'Revisado';
    if(this.rascunhosVinculacao[produtoId]) return 'Rascunho';
    if(this.previaDoProduto(produtoId)?.situacao === 'AMBIGUO') return 'Ambíguo';
    return this.produtoAssociadoVinculacao(produtoId) ? 'Sugerido' : 'Sem par';
  }

  classeBadgeVinculacao(produtoId: number): string {
    switch(this.rotuloProdutoVinculacao(produtoId)) {
      case 'Sem par':
      case 'Erro': return 'cv-badge--error';
      case 'Ambíguo': return 'cv-badge--warning';
      case 'Sugerido':
      case 'Revisado':
      case 'Vinculado': return 'cv-badge--success';
      case 'Rascunho': return 'cv-badge--draft';
      default: return 'cv-badge--neutral';
    }
  }

  naoVinculeProduto(produtoId: number): void {
    if(this.vinculandoExistentes || this.carregandoMesclagem || this.produtoAssociadoVinculacao(produtoId)) return;
    this.ignoradosVinculacao.add(produtoId);
    delete this.mesclagensRevisadas[produtoId];
    delete this.rascunhosVinculacao[produtoId];
    this.statusVinculacaoProdutos[produtoId] = {situacao: 'IGNORADO', mensagem: 'Ignorado nesta análise.'};
    if(this.seletorProdutoIfoodAberto === produtoId) this.seletorProdutoIfoodAberto = null;
  }

  volteAVincularProduto(produtoId: number): void {
    if(this.vinculandoExistentes || this.carregandoMesclagem) return;
    this.ignoradosVinculacao.delete(produtoId);
    delete this.statusVinculacaoProdutos[produtoId];
  }

  selecioneProdutoVinculacao(produtoId: number): void {
    if(this.vinculandoExistentes) return;
    if(this.produtoSelecionadoVinculacaoId === produtoId) {
      if(this.previaDoProduto(produtoId)?.situacao === 'AMBIGUO' && !this.produtosIfoodSelecionados[produtoId] &&
        !this.ignoradosVinculacao.has(produtoId)) {
        this.seletorProdutoIfoodAberto = produtoId;
        this.produtoIfoodBusca = '';
      }
      return;
    }
    this.salveRascunhoVinculacao();
    this.produtoSelecionadoVinculacaoId = produtoId;
    this.mesclagem = null;
    this.erroMesclagem = '';
    this.seletorProdutoIfoodAberto = this.previaDoProduto(produtoId)?.situacao === 'AMBIGUO' &&
      !this.produtosIfoodSelecionados[produtoId] && !this.ignoradosVinculacao.has(produtoId) ? produtoId : null;
    if(this.seletorProdutoIfoodAberto === produtoId) this.produtoIfoodBusca = '';
    ++this.geracaoAnaliseProdutoVinculacao;
    this.carregandoMesclagem = false;
    if(this.produtoAssociadoVinculacao(produtoId) && !this.ignoradosVinculacao.has(produtoId))
      void this.abraMesclagem(produtoId);
  }

  private salveRascunhoVinculacao(): void {
    if(!this.mesclagem || !this.componenteMesclagem) return;
    const produtoId = this.mesclagem.produto.local.id;
    const escolhas = this.componenteMesclagem.obtenhaEscolhas();
    if(!escolhas) return;
    this.rascunhosVinculacao[produtoId] = escolhas;
    const revisao = this.mesclagensRevisadas[produtoId];
    if(revisao && JSON.stringify(revisao.escolhas) !== JSON.stringify(escolhas)) {
      delete this.mesclagensRevisadas[produtoId];
      this.statusVinculacaoProdutos[produtoId] = {situacao: 'RASCUNHO', mensagem: 'Revisão alterada; confirme novamente.'};
    }
  }

  private normalizeTextoBusca(valor: any): string {
    return String(valor || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  }

  private produtoExternoFoiUtilizado(produto: ProdutoCatalogoExternoVinculacaoVM): boolean {
    const mesmoProduto = (candidato: {id?: string; itemId?: string}): boolean =>
      !!((candidato.itemId && candidato.itemId === produto.itemId) ||
        (candidato.id && candidato.id === produto.id));

    if (Object.values(this.produtosIfoodSelecionados).some(selecionado => mesmoProduto(selecionado))) return true;

    return Object.values(this.previaVinculacao).some(previa =>
      previa.situacao === 'ENCONTRADO' && previa.produtosIfood.some(encontrado => mesmoProduto(encontrado)));
  }

  private produtoExternoECorrespondencia(produto: ProdutoCatalogoExternoVinculacaoVM,
                                         correspondencia: {id?: string; itemId?: string}): boolean {
    return !!((correspondencia.itemId && correspondencia.itemId === produto.itemId) ||
      (correspondencia.id && correspondencia.id === produto.id));
  }

  produtosExternosDaCategoria(categoriaNome: string, produtoId?: number): ProdutoCatalogoExternoVinculacaoVM[] {
    const busca = this.normalizeTextoBusca(this.produtoIfoodBusca);
    const previa = produtoId != null ? this.previaDoProduto(produtoId) : null;
    const candidatosAmbiguos = previa?.situacao === 'AMBIGUO' ? previa.produtosIfood : null;
    return this.catalogoExternoVinculacao.filter(item => {
      if (item.categoria.nome !== categoriaNome || this.produtoExternoFoiUtilizado(item)) return false;
      if (candidatosAmbiguos && !candidatosAmbiguos.some(candidato =>
        this.produtoExternoECorrespondencia(item, candidato))) return false;
      if (!busca) return true;
      return [item.nome, item.codigoPdv, item.itemId]
        .some(valor => this.normalizeTextoBusca(valor).includes(busca));
    });
  }

  categoriasCatalogoExterno(produtoId?: number): string[] {
    return Array.from(new Set(this.catalogoExternoVinculacao
      .filter(item => this.produtosExternosDaCategoria(item.categoria.nome, produtoId).includes(item))
      .map(item => item.categoria.nome)));
  }

  abraSeletorProdutoIfood(produtoId: number): void {
    if(this.vinculandoExistentes) return;
    this.seletorProdutoIfoodAberto = this.seletorProdutoIfoodAberto === produtoId ? null : produtoId;
    if (this.seletorProdutoIfoodAberto === produtoId) this.produtoIfoodBusca = '';
  }

  selecioneProdutoIfood(produtoId: number, produto: ProdutoCatalogoExternoVinculacaoVM): void {
    if(this.vinculandoExistentes) return;
    this.ignoradosVinculacao.delete(produtoId);
    delete this.mesclagensRevisadas[produtoId];
    delete this.rascunhosVinculacao[produtoId];
    this.produtosIfoodSelecionados[produtoId] = produto;
    delete this.statusVinculacaoProdutos[produtoId];
    this.seletorProdutoIfoodAberto = null;
    if(this.produtoSelecionadoVinculacaoId === produtoId) void this.abraMesclagem(produtoId);
  }

  canceleSelecaoProdutoIfood(produtoId: number): void {
    if(this.vinculandoExistentes) return;
    delete this.mesclagensRevisadas[produtoId];
    delete this.rascunhosVinculacao[produtoId];
    const selecionados = {...this.produtosIfoodSelecionados};
    delete selecionados[produtoId];
    this.produtosIfoodSelecionados = selecionados;
    delete this.statusVinculacaoProdutos[produtoId];
    this.seletorProdutoIfoodAberto = null;
    this.produtoIfoodBusca = '';
    if(this.produtoSelecionadoVinculacaoId === produtoId) {
      this.mesclagem = null;
      ++this.geracaoAnaliseProdutoVinculacao;
      if(this.produtoAssociadoVinculacao(produtoId)) void this.abraMesclagem(produtoId);
    }
  }

  get nomePlataforma(): string {
    return this.canalSelecionado?.plataforma === 'FOOD99' ? '99Food' : 'iFood';
  }

  get permiteVinculacaoLegada(): boolean {
    return this.canalSelecionado?.plataforma !== 'FOOD99';
  }

  get permiteVinculacaoExistentes(): boolean {
    return ['IFOOD', 'FOOD99'].includes(this.canalSelecionado?.plataforma);
  }

  get canaisDisponiveis(): CanalVendaVM[] {
    return this.canais.filter(canal => ['IFOOD', 'FOOD99'].includes(canal.plataforma));
  }

  get itensVisiveis(): ProdutoCatalogoCanalVendaVM[] {
    return this.pagina?.itens || [];
  }

  get resumoSelecao(): {novos: number; atualizacoes: number; semAlteracoes: number} {
    const resumo = {novos: 0, atualizacoes: 0, semAlteracoes: 0};
    this.itensSelecionadosCarregados().forEach(item => {
      if(item.vinculo === 'SEM_VINCULO') resumo.novos++;
      else if(this.temEdicaoPendente(item) || item.possuiDiferencas ||
          ['PENDENTE', 'ERRO', 'BLOQUEADO'].includes(item.situacaoPublicacao)) resumo.atualizacoes++;
      else resumo.semAlteracoes++;
    });
    return resumo;
  }

  get temSalvamento(): boolean {
    return Object.values(this.edicoes).some(edicao => edicao.salvando);
  }

  get etiquetasSelecionadas(): string[] {
    const etiquetas = new Set<string>();
    this.itensSelecionadosCarregados().forEach(item => {
      if(item.alteracoesCompartilhadas?.length) etiquetas.add('Adicionais');
      this.etiquetasAlteracoes(item.produtoId).forEach(etiqueta => etiquetas.add(etiqueta));
      const edicao = this.edicoes[item.produtoId];
      if(this.temEdicaoPendente(item)) {
        if(edicao.disponivel !== item.disponivel)
          etiquetas.add('Disponibilidade');
      }
    });
    return Array.from(etiquetas);
  }

  async filtreCatalogo(filtro: FiltroCatalogoCanalVenda = this.filtroCatalogo): Promise<void> {
    if(filtro !== this.filtroCatalogo) {
      this.selecaoInicialAlteracoesAplicada = false;
      this.selecionados = new Set<number>();
      this.recursosSelecionados = new Set<number>();
      this.previaLote = null;
    }
    this.filtroCatalogo = filtro;
    this.numeroPagina = 1;
    this.invalideConsultasCatalogo(true);
    await this.carregueCatalogo();
  }

  get totalPaginas(): number {
    return Math.max(1, Math.ceil(Number(this.pagina?.total || 0) / this.tamanhoPagina));
  }

  get quantidadeSelecionada(): number {
    return this.selecionados.size;
  }

  get itensSelecionaveisVisiveis(): ProdutoCatalogoCanalVendaVM[] {
    return this.itensVisiveis.filter(item => this.podeSelecionarProduto(item));
  }

  get paginaSelecionada(): boolean {
    return selecaoDaPaginaCompleta(this.selecionados, this.itensSelecionaveisVisiveis);
  }

  get idsPublicaveis(): number[] {
    return (this.previaLote?.itens || []).filter(item => item.publicavel).map(item => item.produtoId);
  }

  get idsRecursosPublicaveis(): number[] {
    return Array.from(new Set((this.previaLote?.itens || []).filter(item => item.publicavel)
      .reduce((ids, item) => ids.concat(item.recursoIds || []), [] as number[])));
  }

  get precosDaRevisaoConfirmados(): boolean {
    return !this.previaLote?.confirmacaoPrecosToken ||
      this.confirmacaoPrecosToken === this.previaLote.confirmacaoPrecosToken;
  }

  get precosRevisaoValidos(): boolean {
    return (this.previaLote?.precosAConfirmar || []).every(preco => {
      const valor = this.precosRevisao[this.chavePrecoRevisao(preco)];
      return typeof valor === 'number' && Number.isFinite(valor) && valor >= 0 &&
        valor + (preco.origem === 'ESPECIFICO' ? Number(preco.descontoCanal || 0) : 0) <= 99999999.99 &&
        Math.abs(valor * 100 - Math.round(valor * 100)) <= 0.000001;
    });
  }

  rotuloSituacaoLote(situacao: string): string {
    switch(situacao) {
      case 'PENDENTE': return 'Aguardando processamento';
      case 'PROCESSANDO': return 'Em processamento';
      case 'CONCLUIDA': return 'Concluída';
      case 'CONCLUIDA_COM_ERROS': return 'Concluída com erro';
      case 'CANCELADA': return 'Cancelada';
      default: return situacao;
    }
  }

  loteComFalhasResolvidas(lote: ResumoPublicacaoCanalVendaVM): boolean {
    return lote.situacao === 'CONCLUIDA_COM_ERROS' && lote.quantidadeErros > 0 &&
      (lote.quantidadeErrosResolvidos || 0) >= lote.quantidadeErros;
  }

  get publicacoesAtuais(): ResumoPublicacaoCanalVendaVM[] {
    return this.publicacoes.filter(lote => !this.loteComFalhasResolvidas(lote));
  }

  get publicacoesResolvidas(): ResumoPublicacaoCanalVendaVM[] {
    return this.publicacoes.filter(lote => this.loteComFalhasResolvidas(lote));
  }

  get publicacoesEmAndamento(): number {
    return this.publicacoes.filter(lote => ['PENDENTE', 'PROCESSANDO'].includes(lote.situacao)).length;
  }

  get publicacoesConcluidas(): number {
    return this.publicacoes.filter(lote => lote.situacao === 'CONCLUIDA' ||
      this.loteComFalhasResolvidas(lote)).length;
  }

  get publicacoesComProblema(): number {
    return this.publicacoes.filter(lote => lote.situacao === 'CONCLUIDA_COM_ERROS' &&
      (lote.quantidadeErros || 0) > (lote.quantidadeErrosResolvidos || 0)).length;
  }

  rotuloOperacaoItem(operacao: string): string {
    switch(operacao) {
      case 'CRIAR': return 'Criar produto';
      case 'ATUALIZAR': return 'Atualizar produto';
      case 'DESATIVAR': return 'Pausar produto';
      default: return operacao;
    }
  }

  rotuloSituacaoItem(item: ItemPublicacaoCanalVendaVM): string {
    if(item.situacao === 'CANCELADO') return 'Cancelado';
    if(item.situacao === 'SUCESSO') return 'Concluído';
    if(item.codigoErro === 'UPLOAD_99FOOD_CONFIRMADO_COM_DIVERGENCIAS') return 'Upload concluído com ressalvas';
    if(this.rotaIfoodNaoEncontrada(item)) return 'Rota iFood não reconhecida';
    if(item.proximaTentativaEm || item.reconciliacao === 'AUTOMATICA') return 'Verificando resultado';
    if(item.situacao === 'ERRO') return item.reconciliacao === 'NAO_NECESSARIA'
      ? 'Falha no envio' : 'Requer atenção';
    return item.situacao === 'PENDENTE' ? 'Na fila' : 'Em andamento';
  }

  mensagemItem(item: ItemPublicacaoCanalVendaVM): string {
    if(item.situacao === 'SUCESSO') return 'Produto publicado e vínculo confirmado.';
    if(item.situacao === 'CANCELADO') return 'Item cancelado; nenhuma nova alteração será enviada.';
    if(item.situacao === 'ERRO' && ['MENU_99FOOD_DIVERGENTE', 'MENU_99FOOD_REMOVIDO_APOS_ENVIO', 'UPLOAD_99FOOD_CONFIRMADO_COM_DIVERGENCIAS'].includes(item.codigoErro))
      return item.mensagemErro;
    if(item.situacao === 'ERRO' && this.publicacao?.cancelamentoPermitido)
      return 'O produto não foi enviado. Use Começar de novo para descartar a tentativa e revisar os dados atuais.';
    if(item.situacao === 'ERRO' && (item.codigoErro === 'REFERENCIA_IMAGEM_99FOOD_INVALIDA' ||
        item.mensagemErro?.startsWith('Upload sem referencia HTTPS valida.')))
      return 'Não foi possível confirmar a referência da imagem retornada pela 99Food. A publicação foi interrompida na etapa de imagem.';
    if(this.rotaIfoodNaoEncontrada(item))
      return 'A integração usou uma rota que o iFood não reconheceu. Reenvie o produto após atualizar o serviço.';
    if(item.situacao === 'ERRO' && item.reconciliacao !== 'NAO_NECESSARIA')
      return `O produto pode ter sido criado no ${this.nomePlataforma}, mas o vínculo local não foi confirmado.`;
    if(item.situacao === 'ERRO') return 'Não foi possível concluir o envio deste produto.';
    return 'Aguardando o resultado do canal.';
  }

  rotaIfoodNaoEncontrada(item: ItemPublicacaoCanalVendaVM): boolean {
    return item?.codigoErro === 'ROTA_IFOOD_NAO_ENCONTRADA';
  }

  imagemItem(item: ItemPublicacaoCanalVendaVM): string {
    return imagemRevisao(item.produtoImagem);
  }

  trackPublicacao(_indice: number, item: {id: number}): number {
    return item.id;
  }

  tentativasItem(item: ItemPublicacaoCanalVendaVM): string {
    if(item.tentativasEnvio == null || item.consultasResultado == null)
      return `${Number(item.tentativas || 0)} processamento(s)`;
    return `${item.tentativasEnvio} tentativa(s) de envio · ${item.consultasResultado} consulta(s) de resultado`;
  }

  resumoFinalizacaoPublicacao(): string {
    if(!this.publicacao) return '';
    if(this.publicacao.situacao === 'CONCLUIDA_COM_ERROS')
      return `${this.publicacao.quantidadeErros} item(ns) requer(em) atenção.`;
    if(this.publicacao.situacao === 'CANCELADA')
      return `${this.publicacao.quantidadeCancelados || this.publicacao.quantidadeItens} item(ns) cancelado(s).`;
    return `${this.publicacao.quantidadeSucessos} item(ns) concluído(s) com sucesso.`;
  }

  altereDetalhesTecnicos(itemId: number): void {
    const detalhes = new Set(this.detalhesTecnicosPublicacao);
    detalhes.has(itemId) ? detalhes.delete(itemId) : detalhes.add(itemId);
    this.detalhesTecnicosPublicacao = detalhes;
  }

  novaPublicacao(): void {
    this.cancelePoll();
    this.aba = 'PENDENTES';
  }

  async selecioneAbaEnvios(): Promise<void> {
    this.aba = 'PROCESSANDO';
    await this.carreguePublicacoes();
  }

  async atualizeResultados(): Promise<void> {
    await this.carreguePublicacoes();
    if(this.publicacaoId) this.retomeAcompanhamento();
  }

  cancelandoTentativa = false;

  async recomeceProduto(item: ProdutoCatalogoCanalVendaVM): Promise<void> {
    if(this.cancelandoTentativa || !item.ultimoEnvio || item.vinculo !== 'SEM_VINCULO') return;
    this.cancelandoTentativa = true;
    this.erro = '';
    try {
      await this.facade.canceleTentativaNaoEnviada(this.canalSelecionadoId, item.ultimoEnvio.publicacaoId, item.produtoId);
      await this.filtreCatalogo('NOVOS');
      this.selecionados.clear();
      this.selecionados.add(item.produtoId);
      this.notificacao.showSuccess('Tentativa descartada. Revise o produto para criar um novo envio com os dados atuais.');
    } catch(erro) { this.trateErro(erro, 'Não foi possível recomeçar o produto.'); }
    finally { this.cancelandoTentativa = false; }
  }

  async canceleTentativaNaoEnviada(): Promise<void> {
    if(this.cancelandoTentativa || !this.publicacao?.cancelamentoPermitido) return;
    const filtro: FiltroCatalogoCanalVenda = this.publicacao.itens.some(item => item.operacao === 'CRIAR') ? 'NOVOS' : 'ALTERACOES';
    this.cancelandoTentativa = true;
    this.erro = '';
    try {
      await this.facade.canceleTentativaNaoEnviada(this.canalSelecionadoId, this.publicacaoId);
      this.cancelePoll();
      this.publicacao = null;
      this.publicacaoId = null;
      this.aba = 'PENDENTES';
      await this.carreguePublicacoes();
      await this.filtreCatalogo(filtro);
      this.notificacao.showSuccess('Tentativa cancelada. Selecione os produtos para iniciar uma nova revisão.');
    } catch(erro) { this.trateErro(erro, 'Não foi possível cancelar a tentativa.'); }
    finally { this.cancelandoTentativa = false; }
  }

  async reconciliePublicacao(): Promise<void> {
    if(this.vinculandoExistentes || !this.publicacaoId) return;
    const publicacaoId = this.publicacaoId;
    if(this.canalSelecionado?.plataforma === 'FOOD99') {
      this.vinculandoExistentes = true;
      try {
        await this.facade.reconcilieMenuFood99(this.canalSelecionadoId, publicacaoId);
        await this.carreguePublicacoes();
        this.retomeAcompanhamento();
      } catch(erro) { this.trateErro(erro, 'Não foi possível reconciliar a publicação 99Food.'); }
      finally { this.vinculandoExistentes = false; }
      return;
    }
    await this.vinculeExistentes();
    if(publicacaoId === this.publicacaoId) this.abraPublicacao(publicacaoId);
  }

  get exibindoTentativaResolvida(): boolean {
    return this.publicacoesResolvidas.some(lote => lote.id === this.publicacaoId);
  }

  get acompanhamentoTerminal(): boolean {
    return ['CONCLUIDA', 'CONCLUIDA_COM_ERROS', 'CANCELADA']
      .includes(String(this.publicacao?.situacao || ''));
  }

  get publicacaoConfigurada(): boolean {
    return (this.destinos?.capacidadesPorPlataforma?.[this.canalSelecionado?.plataforma || 'IFOOD'] || this.destinos?.capacidades)?.publicacaoConfigurada === true;
  }

  async inicialize(): Promise<void> {
    this.carregando = true;
    this.erro = '';
    try {
      this.destinos = await this.facade.listeDestinos();
      this.canais = this.destinos.canais || await this.facade.listeCanais();
      const primeiroAtivo = this.canaisDisponiveis.find(canal => canal.ativo);
      const canalUrl = Number(this.route.snapshot.queryParamMap.get('canalId'));
      this.canalSelecionadoId = this.canaisDisponiveis.find(canal => canal.id === canalUrl)?.id ||
        primeiroAtivo?.id || this.canaisDisponiveis[0]?.id || null;
      if(this.canalSelecionadoId) await this.carregueCatalogo();
      const publicacaoUrl = Number(this.route.snapshot.queryParamMap.get('publicacaoId'));
      if((this.aba === 'PROCESSANDO' || publicacaoUrl > 0) && this.canalSelecionadoId) {
        await this.carreguePublicacoes();
        if(publicacaoUrl > 0) this.abraPublicacao(publicacaoUrl);
      }
    } catch(erro) {
      this.trateErro(erro, 'Não foi possível carregar os canais de venda.');
    } finally {
      this.carregando = false;
    }
    if(!this.destruido && !this.parametrosSubscription)
      this.parametrosSubscription = this.route.queryParamMap.subscribe(() => void this.consomeVinculacaoUrl());
  }

  private async consomeVinculacaoUrl(): Promise<void> {
    if(this.carregando || this.consumindoVinculacaoUrl || this.destruido ||
      this.route.snapshot.queryParamMap.get('vincular') !== 'true') return;
    const canalId = Number(this.route.snapshot.queryParamMap.get('canalId'));
    this.consumindoVinculacaoUrl = true;
    try {
      await this.router.navigate([], {relativeTo: this.route, replaceUrl: true,
        queryParamsHandling: 'merge', queryParams: {vincular: null}});
      const canal = this.canaisDisponiveis.find(item => item.id === canalId && item.ativo);
      if(!canal) {
        this.erroVinculacao = 'O canal indicado para vinculação não foi encontrado ou está inativo.';
        return;
      }
      this.aba = 'PENDENTES';
      if(this.canalSelecionadoId !== canalId) await this.selecioneCanal(canalId);
      await this.vinculeExistentes();
    } catch(erro) {
      this.erroVinculacao = 'Não foi possível iniciar a vinculação automática. Use o botão para tentar novamente.';
    } finally {
      this.consumindoVinculacaoUrl = false;
    }
  }

  async vinculeExistentes(produtoIds: number[] = null, manterLinhasModal = false): Promise<void> {
    if(!this.canalSelecionado?.ativo || this.vinculandoExistentes || this.publicando || this.temSalvamento || this.aplicandoMassa) return;
    if(!produtoIds?.length) { await this.abraVinculacao(); return; }
    const revisao = this.mesclagensRevisadas[produtoIds[0]];
    if(!revisao) { await this.abraMesclagem(produtoIds[0]); return; }
    const canalId = this.canalSelecionadoId;
    const geracao = this.geracaoCanal;
    this.vinculandoExistentes = true;
    this.resultadoVinculacao = null;
    this.erroVinculacao = '';
    try {
      const resultado = await this.facade.vinculeProdutoComCorrespondencias(
        canalId, produtoIds[0], revisao.itemId, revisao.escolhas);
      if(this.destruido || geracao !== this.geracaoCanal) return;
      this.resultadoVinculacao = resultado;
      for (const item of resultado?.resultados || []) {
        this.statusVinculacaoProdutos[item.produtoId] = {
          situacao: item.situacao,
          mensagem: item.mensagem || item.situacao
        };
      }
      this.previaLote = null;
      this.revisaoAberta = false;
      if (!manterLinhasModal) {
        await Promise.all([this.carregueCatalogo(), this.carreguePublicacoes(),
          this.mostrarVinculacao ? this.carregueProdutosVinculacao() : Promise.resolve(),
          this.mostrarVinculacao ? this.carreguePreviaVinculacao() : Promise.resolve()]);
      }
    } catch(erro) {
      if(!this.destruido && geracao === this.geracaoCanal) {
        const mensagem = erro?.message || 'Falha ao processar a vinculação.';
        this.erroVinculacao = mensagem;
        for (const produtoId of produtoIds || []) {
          this.statusVinculacaoProdutos[produtoId] = {
            situacao: 'FALHA',
            mensagem: this.erroVinculacao
          };
        }
      }
    } finally {
      this.vinculandoExistentes = false;
    }
  }

  async abraVinculacao(): Promise<void> {
    if(!this.canalSelecionado?.ativo || this.vinculandoExistentes) return;
    this.focoAnteriorVinculacao = document.activeElement instanceof HTMLElement
      ? document.activeElement : null;
    this.mostrarVinculacao = true;
    this.paginaVinculacao = null;
    this.erroProdutosVinculacao = '';
    this.erroAnaliseVinculacao = '';
    this.mesclagem = null;
    this.erroMesclagem = '';
    this.mesclagensRevisadas = {};
    this.rascunhosVinculacao = {};
    this.produtoSelecionadoVinculacaoId = null;
    this.buscaProdutosVinculacao = '';
    this.categoriasVinculacaoRecolhidas = new Set<string>();
    this.resultadoVinculacao = null;
    this.previaVinculacao = {};
    this.catalogoExternoVinculacao = [];
    this.produtosIfoodSelecionados = {};
    this.ignoradosVinculacao = new Set<number>();
    this.statusVinculacaoProdutos = {};
    this.seletorProdutoIfoodAberto = null;
    await Promise.all([this.carregueProdutosVinculacao(), this.carreguePreviaVinculacao()]);
    setTimeout(() => this.modalVinculacao?.nativeElement.focus());
  }

  fecheVinculacao(): void {
    if(this.vinculandoExistentes) return;
    ++this.geracaoComparacaoIfood;
    this.produtoComparacaoIfood = null;
    this.comparacaoIfood = null;
    this.carregandoComparacaoIfood = false;
    this.mostrarVinculacao = false;
    this.mesclagem = null;
    ++this.geracaoAnaliseProdutoVinculacao;
    ++this.geracaoListaVinculacao;
    ++this.geracaoPreviaVinculacao;
    this.erroProdutosVinculacao = '';
    this.erroAnaliseVinculacao = '';
    setTimeout(() => this.focoAnteriorVinculacao?.focus());
  }

  teclaVinculacao(evento: KeyboardEvent): void {
    if(evento.key === 'Escape') this.fecheVinculacao();
  }

  async vinculeProdutoDoModal(produtoId: number): Promise<void> {
    this.salveRascunhoVinculacao();
    if(!this.mesclagensRevisadas[produtoId]) { await this.abraMesclagem(produtoId); return; }
    this.statusVinculacaoProdutos[produtoId] = {situacao: 'PROCESSANDO', mensagem: 'Processando…'};
    await this.vinculeExistentes([produtoId], true);
    await this.atualizeDadosAposVinculacao();
    if(this.statusVinculacaoProdutos[produtoId]?.situacao === 'VINCULADO') this.mesclagem = null;
  }

  async abraMesclagem(produtoId: number): Promise<void> {
    if(this.vinculandoExistentes || this.ignoradosVinculacao.has(produtoId)) return;
    const itemId = this.produtosIfoodSelecionados[produtoId]?.itemId ||
      (this.previaDoProduto(produtoId)?.situacao === 'ENCONTRADO'
        ? this.previaDoProduto(produtoId)?.produtosIfood[0]?.itemId : null);
    if(!itemId || !this.canalSelecionadoId) return;
    const canalId = this.canalSelecionadoId;
    const geracao = ++this.geracaoAnaliseProdutoVinculacao;
    this.carregandoMesclagem = true;
    this.mesclagem = null;
    this.erroMesclagem = '';
    try {
      const previa = await this.facade.previsualizeMesclagemVinculacao(canalId, produtoId, itemId);
      if(!this.destruido && this.mostrarVinculacao && canalId === this.canalSelecionadoId &&
        produtoId === this.produtoSelecionadoVinculacaoId && geracao === this.geracaoAnaliseProdutoVinculacao) {
        this.mesclagem = previa;
      }
    } catch(erro) {
      if(geracao === this.geracaoAnaliseProdutoVinculacao)
        this.erroMesclagem = erro?.message || 'Não foi possível analisar os vínculos.';
    } finally {
      if(geracao === this.geracaoAnaliseProdutoVinculacao) this.carregandoMesclagem = false;
    }
  }

  confirmeMesclagem(escolhas: CorrespondenciasVinculacaoProdutoCanalVendaVM): void {
    if(!this.mesclagem) return;
    const produtoId = this.mesclagem.produto.local.id;
    this.mesclagensRevisadas[produtoId] = {itemId: this.mesclagem.produto.externo.id, escolhas};
    delete this.rascunhosVinculacao[produtoId];
    this.statusVinculacaoProdutos[produtoId] = {situacao: 'REVISADO', mensagem: 'Vínculos revisados. Pronto para vincular.'};
  }

  async vinculeTodosDoModal(): Promise<void> {
    this.salveRascunhoVinculacao();
    const ids = this.idsVinculaveis;
    for (const produtoId of ids) {
      this.statusVinculacaoProdutos[produtoId] = {situacao: 'PROCESSANDO', mensagem: 'Processando…'};
      await this.vinculeExistentes([produtoId], true);
    }
    await this.atualizeDadosAposVinculacao();
    if(this.produtoSelecionadoVinculacaoId != null &&
      this.statusVinculacaoProdutos[this.produtoSelecionadoVinculacaoId]?.situacao === 'VINCULADO')
      this.mesclagem = null;
  }

  private async atualizeDadosAposVinculacao(): Promise<void> {
    await Promise.all([this.carregueCatalogo(), this.carreguePublicacoes()]);
  }

  async carreguePreviaVinculacao(): Promise<void> {
    const canalId = this.canalSelecionadoId;
    if(!canalId || !this.mostrarVinculacao) return;
    const geracao = ++this.geracaoPreviaVinculacao;
    this.carregandoAnaliseVinculacao = true;
    this.erroAnaliseVinculacao = '';
    try {
      const previa = await this.facade.previsualizeVinculacao(canalId);
      if(!this.destruido && this.mostrarVinculacao && canalId === this.canalSelecionadoId &&
        geracao === this.geracaoPreviaVinculacao) {
        this.catalogoExternoVinculacao = previa.catalogoExterno || [];
        this.previaVinculacao = previa.itens.reduce((mapa, item) => {
          mapa[item.produtoId] = item;
          return mapa;
        }, {} as {[produtoId: number]: PreviaVinculacaoProdutoCanalVendaVM['itens'][number]});
        if(this.produtoSelecionadoVinculacaoId != null &&
          this.previaDoProduto(this.produtoSelecionadoVinculacaoId)?.situacao === 'AMBIGUO' &&
          !this.produtosIfoodSelecionados[this.produtoSelecionadoVinculacaoId] &&
          !this.ignoradosVinculacao.has(this.produtoSelecionadoVinculacaoId)) {
          this.seletorProdutoIfoodAberto = this.produtoSelecionadoVinculacaoId;
          this.produtoIfoodBusca = '';
        }
        if(this.produtoSelecionadoVinculacaoId != null && !this.mesclagem &&
          this.produtoAssociadoVinculacao(this.produtoSelecionadoVinculacaoId))
          void this.abraMesclagem(this.produtoSelecionadoVinculacaoId);
      }
    } catch(erro) {
      if(!this.destruido && this.mostrarVinculacao && canalId === this.canalSelecionadoId &&
        geracao === this.geracaoPreviaVinculacao)
        this.erroAnaliseVinculacao = erro?.message || 'Não foi possível analisar os vínculos com o catálogo do canal.';
    } finally {
      if(geracao === this.geracaoPreviaVinculacao) this.carregandoAnaliseVinculacao = false;
    }
  }

  async carregueProdutosVinculacao(): Promise<void> {
    const canalId = this.canalSelecionadoId;
    if(!canalId || !this.mostrarVinculacao) return;
    const geracao = ++this.geracaoListaVinculacao;
    this.carregandoProdutosVinculacao = true;
    this.erroProdutosVinculacao = '';
    try {
      const tamanhoPagina = 100;
      const primeira = await this.facade.listeCatalogo(canalId,
        {pagina: 1, tamanhoPagina, vinculo: 'SEM_VINCULO'});
      const itens = [...primeira.itens];
      const totalPaginas = Math.ceil(primeira.total / tamanhoPagina);
      for(let inicio = 2; inicio <= totalPaginas; inicio += 4) {
        if(this.destruido || !this.mostrarVinculacao || canalId !== this.canalSelecionadoId ||
          geracao !== this.geracaoListaVinculacao) return;
        const paginas = await Promise.all(Array.from({length: Math.min(4, totalPaginas - inicio + 1)},
          (_, indice) => this.facade.listeCatalogo(canalId,
            {pagina: inicio + indice, tamanhoPagina, vinculo: 'SEM_VINCULO'})));
        for(const pagina of paginas) itens.push(...pagina.itens);
      }
      if(!this.destruido && this.mostrarVinculacao && canalId === this.canalSelecionadoId &&
        geracao === this.geracaoListaVinculacao) {
        this.paginaVinculacao = {...primeira, itens};
        if(itens.length && !itens.some(produto => produto.produtoId === this.produtoSelecionadoVinculacaoId))
          this.selecioneProdutoVinculacao(itens[0].produtoId);
      }
    } catch(erro) {
      if(!this.destruido && this.mostrarVinculacao && canalId === this.canalSelecionadoId &&
        geracao === this.geracaoListaVinculacao)
        this.erroProdutosVinculacao = 'Não foi possível carregar os produtos sem vínculo deste canal.';
    } finally {
      if(geracao === this.geracaoListaVinculacao) this.carregandoProdutosVinculacao = false;
    }
  }

  async selecioneCanal(valor: any): Promise<void> {
    if(this.vinculandoExistentes) return;
    this.resultadoVinculacao = null;
    this.erroVinculacao = '';
    this.confirmarDesativacao = false;
    this.confirmarRemocao = false;
    this.confirmarDescarte = false;
    this.recursosParaCancelar = [];
    if(this.buscaTimer) clearTimeout(this.buscaTimer);
    this.buscaTimer = null;
    this.geracaoCanal++;
    this.invalideConsultasCatalogo();
    this.canalSelecionadoId = valor ? Number(valor) : null;
    this.numeroPagina = 1;
    this.busca = '';
    this.categoriaId = null;
    this.filtroCatalogo = 'ALTERACOES';
    this.selecaoInicialAlteracoesAplicada = false;
    this.filtroDisponibilidade = 'TODAS';
    this.produtosCarregados = {};
    this.resumosPrevia = {};
    this.historico = null;
    this.produtoHistorico = null;
    this.erroHistorico = '';
    this.geracaoHistorico++;
    this.selecionados = new Set<number>();
    this.recursosSelecionados = new Set<number>();
    this.edicoes = {};
    this.previas = {};
    this.expandidos = new Set<number>();
    this.carregandoPrevia = new Set<number>();
    this.requisicoesPrevia = {};
    this.pagina = null;
    this.carregandoCatalogo = false;
    this.previaLote = null;
    this.revisaoAberta = false;
    this.publicacao = null;
    this.publicacaoId = null;
    this.publicacoes = [];
    this.mostrarVinculacao = false;
    this.mesclagem = null;
    this.erroMesclagem = '';
    this.mesclagensRevisadas = {};
    this.rascunhosVinculacao = {};
    this.produtoSelecionadoVinculacaoId = null;
    this.buscaProdutosVinculacao = '';
    this.categoriasVinculacaoRecolhidas = new Set<string>();
    ++this.geracaoAnaliseProdutoVinculacao;
    ++this.geracaoListaVinculacao;
    ++this.geracaoPreviaVinculacao;
    this.paginaVinculacao = null;
    this.previaVinculacao = {};
    this.catalogoExternoVinculacao = [];
    this.produtosIfoodSelecionados = {};
    this.ignoradosVinculacao = new Set<number>();
    this.seletorProdutoIfoodAberto = null;
    this.carregandoAnaliseVinculacao = false;
    this.erroAnaliseVinculacao = '';
    this.cancelePoll();
    if(this.canalSelecionadoId) await this.carregueCatalogo();
    if(this.aba === 'PROCESSANDO' && this.canalSelecionadoId) await this.carreguePublicacoes();
  }

  async carregueCatalogo(): Promise<void> {
    if(!this.canalSelecionadoId) return;
    const canalVendaId = Number(this.canalSelecionadoId);
    const geracaoCanal = this.geracaoCanal;
    const geracaoCatalogo = ++this.geracaoCatalogo;
    ++this.geracaoContexto;
    this.requisicoesPrevia = {};
    this.carregandoPrevia = new Set<number>();
    this.carregandoCatalogo = true;
    this.erro = '';
    try {
      const filtros: any = {
        pagina: this.numeroPagina,
        tamanhoPagina: this.tamanhoPagina,
        busca: this.busca.trim() || undefined,
        categoriaId: this.categoriaId || undefined
      };
      if(this.filtroCatalogo === 'NOVOS') filtros.vinculo = 'SEM_VINCULO';
      if(this.filtroCatalogo === 'PUBLICADOS') filtros.vinculo = 'VINCULADO';
      if(this.filtroCatalogo === 'ALTERACOES' || this.filtroCatalogo === 'ATUALIZADOS') {
        filtros.vinculo = 'VINCULADO';
        filtros.statusPublicacao = this.filtroCatalogo === 'ALTERACOES' ? 'PENDENTE' : 'PUBLICADO';
      }
      if(this.filtroDisponibilidade !== 'TODAS') {
        filtros.vender = true;
        filtros.disponivel = this.filtroDisponibilidade === 'DISPONIVEIS';
      }
      const pagina = await this.facade.listeCatalogo(canalVendaId, filtros);
      if(!this.consultaCatalogoAtual(geracaoCanal, geracaoCatalogo, canalVendaId)) return;
      const edicoes = {...this.edicoes};
      (pagina.itens || []).forEach(item => {
        const anterior = this.produtosCarregados[item.produtoId];
        if(this.selecionados.has(item.produtoId)) {
          (anterior?.recursoIds || []).forEach(id => this.recursosSelecionados.delete(id));
          (item.recursoIds || []).forEach(id => this.recursosSelecionados.add(id));
        }
        if(!anterior || (!this.temEdicaoPendente(anterior) && !edicoes[item.produtoId]?.salvando))
          edicoes[item.produtoId] = this.crieEdicao(item);
        this.produtosCarregados[item.produtoId] = item;
        delete this.resumosPrevia[item.produtoId];
        delete this.previas[item.produtoId];
      });
      this.edicoes = edicoes;
      this.pagina = pagina;
      (pagina.itens || []).forEach(item => {
        if(!this.podeSelecionarProduto(item)) this.selecionados.delete(item.produtoId);
      });
      if(this.filtroCatalogo === 'ALTERACOES' && this.selecaoAutomaticaAlteracoes && !this.selecaoInicialAlteracoesAplicada) {
        this.itensSelecionaveisVisiveis.forEach(item => {
          this.selecionados.add(item.produtoId);
        });
        this.previaLote = null;
        this.selecaoInicialAlteracoesAplicada = true;
      }
      this.selecionados = new Set(this.selecionados);
      this.sincronizeRecursosSelecionados();
      void this.carregueResumosPagina(geracaoCanal, geracaoCatalogo, canalVendaId);
      this.expandidos.forEach(produtoId => {
        if(pagina.itens.some(item => item.produtoId === produtoId))
          void this.carreguePreviaProduto(produtoId);
      });
    } catch(erro) {
      if(this.consultaCatalogoAtual(geracaoCanal, geracaoCatalogo, canalVendaId))
        this.trateErro(erro, 'Não foi possível carregar o catálogo deste canal.');
    } finally {
      if(this.consultaCatalogoAtual(geracaoCanal, geracaoCatalogo, canalVendaId))
        this.carregandoCatalogo = false;
    }
  }

  private async carregueResumosPagina(
    geracaoCanal: number, geracaoCatalogo: number, canalVendaId: number
  ): Promise<void> {
    this.erroResumos = false;
    const produtos = this.itensVisiveis.filter(item => item.vinculo === 'VINCULADO' &&
      item.situacaoPublicacao === 'PENDENTE').map(item => item.produtoId);
    if(!produtos.length || !this.canalSelecionado?.ativo) return;
    try {
      const previa = await this.facade.gerePrevia(canalVendaId, {
        produtoIds: produtos, incluirSnapshot: false
      });
      if(!this.consultaCatalogoAtual(geracaoCanal, geracaoCatalogo, canalVendaId)) return;
      previa.itens.forEach(item => this.resumosPrevia[item.produtoId] = item);
    } catch(erro) {
      if(this.consultaCatalogoAtual(geracaoCanal, geracaoCatalogo, canalVendaId)) this.erroResumos = true;
    }
  }

  etiquetasAlteracoes(produtoId: number): string[] {
    const previa = this.previas[produtoId] || this.resumosPrevia[produtoId];
    const etiquetas = new Set<string>();
    (previa?.diferencas || []).forEach(diferenca => {
      const caminho = diferenca.caminho;
      if(diferenca.tipo === 'CRIAR' && /^estrutura\.gruposAdicionais\[[^\]]+\]$/.test(caminho))
        etiquetas.add('Adicional incluído');
      else if(caminho.startsWith('estrutura.')) etiquetas.add('Adicionais');
      else if(caminho.startsWith('conteudo.imagem')) etiquetas.add('Imagem');
      else if(caminho === 'conteudo.descricao') etiquetas.add('Descrição');
      else if(caminho === 'conteudo.nome') etiquetas.add('Nome');
      else if(caminho === 'conteudo.categoriaExternaId') etiquetas.add('Categoria');
      else if(caminho.startsWith('comercial.preco')) etiquetas.add('Preço');
      else if(caminho === 'comercial.disponivel')
        etiquetas.add('Disponibilidade');
    });
    return Array.from(etiquetas);
  }

  precoPublicado(produtoId: number): number | null {
    const previa = this.previas[produtoId] || this.resumosPrevia[produtoId];
    const diferenca = previa?.diferencas.find(item => item.caminho === 'comercial.preco');
    return typeof diferenca?.antes === 'number' ? diferenca.antes : null;
  }

  rotuloProduto(item: ProdutoCatalogoCanalVendaVM): string {
    if(['PUBLICANDO', 'ERRO', 'BLOQUEADO'].includes(item.situacaoPublicacao))
      return this.rotuloSituacaoProduto(item.situacaoPublicacao);
    if(item.vinculo === 'SEM_VINCULO') return 'Não publicado';
    if(this.temErroCompartilhado(item)) return 'Erro no adicional';
    if(item.situacaoPublicacao === 'PUBLICADO' && item.alteracoesCompartilhadas?.length)
      return 'Alterações pendentes';
    if(item.situacaoPublicacao === 'PUBLICADO') return 'Atualizado';
    return item.situacaoPublicacao === 'PENDENTE' ? 'Alterações pendentes' : `Vinculado ao ${this.nomePlataforma}`;
  }

  temErroCompartilhado(item: ProdutoCatalogoCanalVendaVM): boolean {
    return (item.alteracoesCompartilhadas || []).some(adicional => adicional.situacao === 'ERRO');
  }

  descricaoProdutosAfetados(adicional: AlteracaoCompartilhadaCanalVendaVM): string {
    const outros = Math.max(0, Number(adicional.quantidadeProdutosAfetados || 0) - 1);
    if(!outros) return 'Usado somente neste produto';
    return `Usado neste produto + outros ${outros} ${outros === 1 ? 'produto' : 'produtos'}`;
  }

  valorAlteracaoCompartilhada(valor: any, campo: string): string {
    if(valor === null || valor === undefined || valor === '') return '—';
    if(typeof valor === 'boolean') return valor ? 'Disponível' : 'Pausada';
    if(campo === 'preco' && typeof valor === 'number')
      return valor.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'});
    return this.valorDiferenca(valor);
  }

  imagemSnapshot(snapshot: any): string {
    return imagemRevisao(snapshot?.conteudo?.imagem?.url);
  }

  temEdicaoPendente(item: ProdutoCatalogoCanalVendaVM): boolean {
    const edicao = this.edicoes[item.produtoId];
    if(!edicao) return false;
    return edicao.disponivel !== item.disponivel;
  }

  precosIguais(base: number | null, canal: number | null): boolean {
    return base != null && canal != null && Number.isFinite(base) && Number.isFinite(canal) &&
      Math.round((base + Number.EPSILON) * 100) === Math.round((canal + Number.EPSILON) * 100);
  }

  async altereDisponibilidade(item: ProdutoCatalogoCanalVendaVM, ativo: boolean): Promise<void> {
    const edicao = this.edicoes[item.produtoId];
    if(!edicao || edicao.salvando || this.publicando) return;
    edicao.disponivel = ativo;
    this.previaLote = null;
    await this.salveProduto(item);
  }

  pesquise(): void {
    if(this.buscaTimer) clearTimeout(this.buscaTimer);
    this.invalideConsultasCatalogo(true);
    this.carregandoCatalogo = true;
    this.buscaTimer = setTimeout(() => {
      this.buscaTimer = null;
      this.numeroPagina = 1;
      void this.carregueCatalogo();
    }, 350);
  }

  async mudePagina(pagina: number): Promise<void> {
    if(pagina < 1 || pagina > this.totalPaginas || pagina === this.numeroPagina) return;
    this.invalideConsultasCatalogo(true);
    this.numeroPagina = pagina;
    await this.carregueCatalogo();
  }

  altereSelecaoProduto(produtoId: number, marcado: boolean): void {
    if(this.publicando || this.aplicandoMassa) return;
    const item = this.produtosCarregados[produtoId];
    if(marcado && (!item || !this.podeSelecionarProduto(item))) return;
    if(this.filtroCatalogo === 'ALTERACOES' && !marcado) this.selecaoAutomaticaAlteracoes = false;
    marcado ? this.selecionados.add(produtoId) : this.selecionados.delete(produtoId);
    this.selecionados = new Set(this.selecionados);
    this.sincronizeRecursosSelecionados();
    this.previaLote = null;
  }

  altereSelecaoPagina(marcado: boolean): void {
    if(this.publicando || this.aplicandoMassa) return;
    if(this.filtroCatalogo === 'ALTERACOES') this.selecaoAutomaticaAlteracoes = marcado;
    this.selecionados = altereSelecaoPagina(
      this.selecionados, this.itensSelecionaveisVisiveis, marcado
    );
    this.sincronizeRecursosSelecionados();
    this.previaLote = null;
  }

  limpeSelecao(): void {
    if(this.publicando || this.aplicandoMassa) return;
    if(this.filtroCatalogo === 'ALTERACOES') this.selecaoAutomaticaAlteracoes = false;
    this.selecionados = new Set<number>();
    this.recursosSelecionados = new Set<number>();
    this.previaLote = null;
  }

  estaSelecionado(produtoId: number): boolean {
    return this.selecionados.has(produtoId);
  }

  podeSelecionarProduto(item: ProdutoCatalogoCanalVendaVM): boolean {
    return produtoPodeSerSelecionadoParaPublicacao(item) || this.temEdicaoPendente(item);
  }

  async expandaProduto(item: ProdutoCatalogoCanalVendaVM): Promise<void> {
    if(this.expandidos.has(item.produtoId)) {
      this.expandidos.delete(item.produtoId);
      this.expandidos = new Set(this.expandidos);
      return;
    }
    this.expandidos.add(item.produtoId);
    this.expandidos = new Set(this.expandidos);
    await this.carreguePreviaProduto(item.produtoId);
  }

  async carreguePreviaProduto(produtoId: number): Promise<void> {
    if(!this.canalSelecionadoId || this.carregandoPrevia.has(produtoId)) return;
    const canalVendaId = Number(this.canalSelecionadoId);
    const geracaoCanal = this.geracaoCanal;
    const geracaoContexto = this.geracaoContexto;
    const geracaoPrevia = ++this.geracaoPrevia;
    this.requisicoesPrevia[produtoId] = geracaoPrevia;
    this.carregandoPrevia.add(produtoId);
    this.carregandoPrevia = new Set(this.carregandoPrevia);
    try {
      const item = this.produtosCarregados[produtoId];
      const previa = await this.facade.gerePrevia(canalVendaId, {
        produtoIds: this.produtoPrecisaPublicar(item) ? [produtoId] : [],
        recursoIds: item?.recursoIds || [],
        incluirSnapshot: true
      });
      if(this.consultaPreviaAtual(
        produtoId, geracaoPrevia, geracaoCanal, geracaoContexto, canalVendaId
      ) && previa.itens[0])
        this.previas = {...this.previas, [produtoId]: previa.itens[0]};
    } catch(erro) {
      if(this.consultaPreviaAtual(
        produtoId, geracaoPrevia, geracaoCanal, geracaoContexto, canalVendaId
      )) this.trateErro(erro, 'Não foi possível gerar a prévia deste produto.');
    } finally {
      if(this.requisicoesPrevia[produtoId] === geracaoPrevia) {
        delete this.requisicoesPrevia[produtoId];
        this.carregandoPrevia.delete(produtoId);
        this.carregandoPrevia = new Set(this.carregandoPrevia);
      }
    }
  }

  async salveProduto(item: ProdutoCatalogoCanalVendaVM, atualize = true): Promise<boolean> {
    if(!this.canalSelecionadoId || !this.canalSelecionado?.ativo) return false;
    const canalId = this.canalSelecionadoId;
    const geracao = this.geracaoCanal;
    const edicao = this.edicoes[item.produtoId];
    if(!edicao || edicao.salvando) return false;
    const configuracao: ConfiguracaoProdutoCanalVenda = {
      vender: true,
      disponivel: edicao.disponivel
    };
    edicao.salvando = true;
    try {
      const resposta = await this.facade.configureProduto(canalId, item.produtoId, configuracao);
      if(this.destruido || geracao !== this.geracaoCanal || canalId !== this.canalSelecionadoId) return false;
      this.produtosCarregados[item.produtoId] = resposta.produto;
      if(this.pagina) this.pagina.itens = this.pagina.itens.map(atual =>
        atual.produtoId === item.produtoId ? resposta.produto : atual);
      this.edicoes[item.produtoId] = this.crieEdicao(resposta.produto);
      this.resumosPrevia[item.produtoId] = resposta.previa;
      delete this.previas[item.produtoId];
      this.previaLote = null;
      if(atualize) {
        this.notificacao.showSuccess('Configuração salva. Nada foi publicado automaticamente.');
        await this.carregueCatalogo();
      }
      return true;
    } catch(erro) {
      if(geracao === this.geracaoCanal && canalId === this.canalSelecionadoId && !this.destruido)
        this.trateErro(erro, 'Não foi possível salvar a configuração do canal.');
      return false;
    } finally {
      edicao.salvando = false;
    }
  }

  async apliqueOperacaoMassa(): Promise<void> {
    if(this.aplicandoMassa || this.publicando || this.temSalvamento || !this.canalSelecionadoId || !this.operacaoMassa || !this.selecionados.size) return;
    if(!['DISPONIVEL', 'PAUSAR'].includes(this.operacaoMassa)) return;
    if(this.selecionados.size > 200) {
      this.notificacao.showWarning('Operações em massa aceitam no máximo 200 produtos.');
      return;
    }
    const dados: any = {produtoIds: Array.from(this.selecionados), operacao: this.operacaoMassa};
    this.aplicandoMassa = true;
    try {
      const resultado = await this.facade.apliqueMassa(this.canalSelecionadoId, dados);
      resultado.resultados.forEach(linha => {
        if(!linha.sucesso || !linha.produto) return;
        this.produtosCarregados[linha.produtoId] = linha.produto;
        this.edicoes[linha.produtoId] = this.crieEdicao(linha.produto);
        delete this.resumosPrevia[linha.produtoId];
        delete this.previas[linha.produtoId];
      });
      resultado.erros
        ? this.notificacao.showWarning(`${resultado.sucessos} salvos e ${resultado.erros} com erro.`)
        : this.notificacao.showSuccess(`${resultado.sucessos} produtos atualizados. Nada foi publicado.`);
      this.previaLote = null;
      await this.carregueCatalogo();
    } catch(erro) {
      this.trateErro(erro, 'Não foi possível aplicar a operação em massa.');
    } finally {
      this.aplicandoMassa = false;
    }
  }

  resolucoesAdicionaisIfood: {[grupoId: number]: ResolucaoAdicionalIfoodVM | null} = {};

  get adicionaisIfoodResolvidos(): boolean {
    return !this.camposComparacaoIfood['adicionaisFaltantes'] ||
      (this.comparacaoIfood?.adicionais || []).every(it => !!this.resolucoesAdicionaisIfood[it.local.alvoLocalId]);
  }

  async compareComIfood(item: ProdutoCatalogoCanalVendaVM): Promise<void> {
    if(!this.canalSelecionadoId || this.canalSelecionado?.plataforma !== 'IFOOD' ||
        this.filtroCatalogo !== 'PUBLICADOS' || this.salvandoComparacaoIfood) return;
    const canalId = this.canalSelecionadoId;
    const geracao = ++this.geracaoComparacaoIfood;
    if(!this.produtoComparacaoIfood) this.focoAnteriorComparacaoIfood = document.activeElement as HTMLElement;
    this.produtoComparacaoIfood = item;
    this.comparacaoIfood = null;
    this.camposComparacaoIfood = {};
    this.resolucoesAdicionaisIfood = {};
    this.mapeandoComparacaoIfood = false;
    this.categoriaComparacaoIfood = '';
    this.erroComparacaoIfood = '';
    this.pendenciasComparacaoIfood = [];
    this.carregandoComparacaoIfood = true;
    setTimeout(() => this.modalComparacaoIfood?.nativeElement.focus());
    try {
      const comparacao = await this.facade.compareProdutoIfood(canalId, item.produtoId);
      if(this.destruido || canalId !== this.canalSelecionadoId || geracao !== this.geracaoComparacaoIfood) return;
      this.comparacaoIfood = comparacao;
    } catch(erro) {
      if(geracao === this.geracaoComparacaoIfood)
        this.mostreErroComparacaoIfood(erro, 'Não foi possível consultar o iFood.');
    } finally {
      if(geracao === this.geracaoComparacaoIfood) this.carregandoComparacaoIfood = false;
    }
  }

  fecheComparacaoIfood(): void {
    if(this.salvandoComparacaoIfood) return;
    ++this.geracaoComparacaoIfood;
    this.produtoComparacaoIfood = null;
    this.comparacaoIfood = null;
    this.pendenciasComparacaoIfood = [];
    this.carregandoComparacaoIfood = false;
    this.focoAnteriorComparacaoIfood?.focus();
  }

  private mostreErroComparacaoIfood(erro: ErroHttpCanalVenda, mensagem: string): void {
    this.erroComparacaoIfood = erro.message || mensagem;
    this.pendenciasComparacaoIfood = erro.codigo === 'ADICIONAIS_PENDENTES_COMPARACAO_IFOOD'
      ? erro.pendenciasAdicionais || [] : [];
  }

  async revisePendenciasComparacaoIfood(): Promise<void> {
    if(!this.pendenciasComparacaoIfood.length || this.salvandoComparacaoIfood || this.publicando || this.temSalvamento) return;
    this.selecionados = new Set<number>();
    this.recursosSelecionados = new Set(this.pendenciasComparacaoIfood.map(item => item.recursoId));
    this.fecheComparacaoIfood();
    await this.revisePublicacao();
  }

  teclaComparacaoIfood(evento: KeyboardEvent): void {
    if(evento.key === 'Escape') { evento.preventDefault(); this.fecheComparacaoIfood(); }
    if(evento.key !== 'Tab') return;
    const elementos = Array.from(this.modalComparacaoIfood?.nativeElement.querySelectorAll<HTMLElement>(
      'button:not([disabled]), input:not([disabled])') || []);
    const primeiro = elementos[0], ultimo = elementos[elementos.length - 1];
    if(evento.shiftKey && (document.activeElement === primeiro || document.activeElement === this.modalComparacaoIfood?.nativeElement)) {
      evento.preventDefault(); ultimo?.focus();
    } else if(!evento.shiftKey && document.activeElement === ultimo) {
      evento.preventDefault(); primeiro?.focus();
    }
  }

  trechosComparacaoIfood(valor: any, outro: any): Array<{texto: string; diferente: boolean}> {
    const palavras = String(valor || '—').split(/(\s+)/);
    const anteriores = String(outro || '—').split(/(\s+)/);
    let inicio = 0;
    while(inicio < palavras.length && inicio < anteriores.length && palavras[inicio] === anteriores[inicio]) inicio++;
    let fim = palavras.length, fimAnterior = anteriores.length;
    while(fim > inicio && fimAnterior > inicio && palavras[fim - 1] === anteriores[fimAnterior - 1]) { fim--; fimAnterior--; }
    return [{texto: palavras.slice(0, inicio).join(''), diferente: false},
      {texto: palavras.slice(inicio, fim).join(''), diferente: true},
      {texto: palavras.slice(fim).join(''), diferente: false}].filter(item => !!item.texto);
  }

  get linhasComparacaoIfood(): ComparacaoAtualIfoodVM['diferencas'] {
    const linhas = this.comparacaoIfood?.diferencas || [];
    if(!this.comparacaoIfood?.avisoCategoria || linhas.some(item => item.campo === 'categoriaExternaId')) return linhas;
    return [...linhas, {campo: 'categoriaExternaId', rotulo: 'Categoria', antes: null, depois: null,
      nomeAntes: null, nomeDepois: this.produtoComparacaoIfood?.categoria?.nome || null,
      bloqueio: this.comparacaoIfood.avisoCategoria}];
  }

  get diferencasComparacaoIfood(): number {
    return (this.comparacaoIfood?.diferencas || []).filter(item => !item.bloqueio).length;
  }

  get bloqueiosComparacaoIfood(): number {
    return this.linhasComparacaoIfood.filter(item => !!item.bloqueio).length;
  }

  async abraMapeamentoComparacaoIfood(): Promise<void> {
    this.mapeandoComparacaoIfood = true;
    await this.carregueCategoriasExternas();
  }

  async salveMapeamentoComparacaoIfood(): Promise<void> {
    const produto = this.produtoComparacaoIfood;
    const canalId = this.canalSelecionadoId;
    const geracao = this.geracaoComparacaoIfood;
    if(!produto?.categoria?.id || !canalId || !this.categoriaComparacaoIfood || this.salvandoComparacaoIfood) return;
    this.salvandoComparacaoIfood = true;
    this.erroComparacaoIfood = '';
    try {
      await this.facade.resolvaCategoria(canalId, produto.categoria.id, {
        modo: 'EXISTENTE', categoriaExternaId: this.categoriaComparacaoIfood
      });
      if(this.destruido || canalId !== this.canalSelecionadoId || geracao !== this.geracaoComparacaoIfood) return;
      this.salvandoComparacaoIfood = false;
      await this.compareComIfood(produto);
    } catch(erro) {
      if(geracao === this.geracaoComparacaoIfood)
        this.erroComparacaoIfood = erro.message || 'Não foi possível salvar o mapeamento da categoria.';
    } finally {
      this.salvandoComparacaoIfood = false;
    }
  }

  get camposIfoodSelecionados(): string[] {
    return (this.comparacaoIfood?.diferencas || []).filter(it => !it.bloqueio && this.camposComparacaoIfood[it.campo])
      .map(it => it.campo);
  }

  async adicioneComparacaoARevisao(recriar = false): Promise<void> {
    if(!this.canalSelecionadoId || !this.comparacaoIfood || this.salvandoComparacaoIfood) return;
    if(recriar ? !this.comparacaoIfood.ausente : (this.comparacaoIfood.ausente || !this.camposIfoodSelecionados.length)) return;
    const canalId = this.canalSelecionadoId;
    const geracao = this.geracaoComparacaoIfood;
    const comparacao = this.comparacaoIfood;
    this.salvandoComparacaoIfood = true;
    this.erroComparacaoIfood = '';
    this.pendenciasComparacaoIfood = [];
    try {
      if(recriar) await this.facade.prepareProdutoAusenteIfood(canalId, comparacao.produtoId, comparacao.versao);
      else {
        if(!this.adicionaisIfoodResolvidos) return;
        await this.facade.adicioneComparacaoIfoodRevisao(canalId, comparacao.produtoId, comparacao.versao,
          this.camposIfoodSelecionados, this.camposComparacaoIfood['adicionaisFaltantes']
            ? Object.values(this.resolucoesAdicionaisIfood).filter(Boolean) : []);
      }
      if(this.destruido || canalId !== this.canalSelecionadoId || geracao !== this.geracaoComparacaoIfood) return;
      if(recriar) {
        this.filtroCatalogo = 'NOVOS';
        this.numeroPagina = 1;
        this.produtosCarregados[comparacao.produtoId] = {...this.produtoComparacaoIfood,
          vinculo: 'SEM_VINCULO', situacaoPublicacao: 'PENDENTE', possuiDiferencas: true};
      }
      this.produtoComparacaoIfood = null;
      this.comparacaoIfood = null;
      await this.carregueCatalogo();
      if(this.destruido || canalId !== this.canalSelecionadoId || geracao !== this.geracaoComparacaoIfood) return;
      this.selecionados = new Set([comparacao.produtoId]);
      this.recursosSelecionados = new Set<number>();
      await this.revisePublicacao();
    } catch(erro) {
      if(canalId === this.canalSelecionadoId && geracao === this.geracaoComparacaoIfood) {
        if(recriar) this.comparacaoIfood = null;
        this.mostreErroComparacaoIfood(erro, 'Não foi possível adicionar à revisão.');
        if(!this.produtoComparacaoIfood) this.trateErro(erro, this.erroComparacaoIfood);
      }
    } finally {
      this.salvandoComparacaoIfood = false;
    }
  }

  async revisePublicacao(): Promise<void> {
    if(!this.canalSelecionadoId || (!this.selecionados.size && !this.recursosSelecionados.size) ||
        this.publicando || this.temSalvamento) return;
    const canalId = this.canalSelecionadoId;
    const geracao = this.geracaoCanal;
    if(this.selecionados.size > 100) {
      this.notificacao.showWarning('Revise no máximo 100 produtos por vez.');
      return;
    }
    this.publicando = true;
    try {
      for(const item of this.itensSelecionadosCarregados()) {
        if(this.destruido || canalId !== this.canalSelecionadoId || geracao !== this.geracaoCanal) return;
        if(this.temEdicaoPendente(item) && !await this.salveProduto(item, false)) return;
      }
      const produtoIds = this.produtoIdsSelecionadosParaPublicacao();
      const previa = await this.facade.gerePrevia(canalId, {
        produtoIds,
        recursoIds: Array.from(this.recursosSelecionados),
        incluirSnapshot: this.selecionados.size <= 20
      });
      if(this.destruido || canalId !== this.canalSelecionadoId || geracao !== this.geracaoCanal) return;
      this.previaLote = previa;
      this.prepareComparacoesRevisao();
      this.erroRevisao = '';
      this.revisaoAberta = true;
      if(this.previaLote.itens.some(item => this.categoriaPendente(item)))
        await this.carregueCategoriasExternas();
    } catch(erro) {
      this.trateErro(erro, 'Não foi possível revisar os produtos selecionados.');
    } finally {
      this.publicando = false;
    }
  }

  categoriaPendente(item: PreviaProdutoCanalVendaVM): boolean {
    return (item.bloqueios || []).some(bloqueio => bloqueio.codigo === 'CATEGORIA_NAO_MAPEADA');
  }

  get novosNaRevisao(): number {
    return (this.previaLote?.itens || []).filter(item => item.operacao === 'CRIAR').length;
  }

  get alteradosNaRevisao(): number {
    return (this.previaLote?.itens || []).filter(item =>
      item.operacao !== 'CRIAR' && item.operacao !== 'NENHUMA' && item.diferencas.length > 0).length;
  }

  linhasDaAbaRevisao(produtoId: number): LinhaRevisaoCanalVenda[] {
    const comparacao = this.comparacoesRevisao[produtoId];
    if(!comparacao) return [];
    const aba = this.abasRevisao[produtoId] || 'PRODUTO';
    return comparacao.completas.filter(linha => linha.secao === aba);
  }

  nomeProdutoRevisao(item: PreviaProdutoCanalVendaVM): string {
    return item.desejado?.conteudo.nome || this.produtoDaPrevia(item.produtoId)?.nome ||
      item.publicado?.conteudo.nome || `Produto #${item.produtoId}`;
  }

  imagemProdutoRevisao(item: PreviaProdutoCanalVendaVM): string {
    return [this.produtoDaPrevia(item.produtoId)?.imagem,
      item.desejado?.conteudo.imagem?.url, item.publicado?.conteudo.imagem?.url]
      .map(imagemRevisao).find(url => !!url && !this.imagensComErro.has(url)) || '';
  }

  rotuloOperacaoRevisao(item: PreviaProdutoCanalVendaVM): string {
    switch(item.operacao) {
      case 'CRIAR': return `Criar produto no ${this.nomePlataforma}`;
      case 'ATUALIZAR': return 'Atualizar produto';
      case 'DESATIVAR': return 'Pausar produto no canal';
      case 'NENHUMA': return 'Sem alterações · não será enviado';
      default: return 'Requer atenção antes do envio';
    }
  }

  private prepareComparacoesRevisao(): void {
    this.detalhesRevisao = new Set<number>();
    this.gruposRevisaoRecolhidos = new Set<string>();
    this.abasRevisao = {};
    this.carregandoDetalhesRevisao = new Set<number>();
    this.errosDetalhesRevisao = {};
    this.comparacoesRevisao = {};
    this.revisaoDesatualizada = false;
    this.confirmacaoPrecosToken = null;
    this.precosRevisao = {};
    this.precosRevisaoPorProduto = {};
    this.precosRevisaoRecolhidos.clear();
    (this.previaLote?.precosAConfirmar || []).forEach(preco => {
      this.precosRevisao[this.chavePrecoRevisao(preco)] = preco.precoFinal;
      preco.produtoIds.forEach(produtoId => {
        (this.precosRevisaoPorProduto[produtoId] ||= []).push(preco);
      });
    });
    Object.values(this.precosRevisaoPorProduto).forEach(precos =>
      precos.sort((a, b) => Number(b.tipo === 'PRODUTO') - Number(a.tipo === 'PRODUTO')));
    (this.previaLote?.itens || []).forEach(item => {
      if('desejado' in item) this.monteComparacaoRevisao(item);
    });
    if(this.previaLote?.itens.length === 1) this.detalhesRevisao.add(this.previaLote.itens[0].produtoId);
  }

  rotuloOrigemPrecoRevisao(preco: PrecoConfirmacaoCanalVendaVM): string {
    if(preco.origem === 'ESPECIFICO') return 'Preço específico deste canal';
    if(preco.origem === 'PERCENTUAL_CANAL' && Number(preco.percentual) === 0)
      return 'Sugestão: preço do Promokit';
    if(preco.origem === 'PERCENTUAL_CANAL')
      return `Sugestão: regra do canal (${Number(preco.percentual) > 0 ? '+' : ''}${preco.percentual}%)`;
    return 'Mesmo preço do MeuCardápio';
  }

  chavePrecoRevisao(preco: PrecoConfirmacaoCanalVendaVM): string {
    return `${preco.tipo}:${preco.alvoId}`;
  }

  alterneAdicionaisRevisao(produtoId: number): void {
    if(this.precosRevisaoRecolhidos.has(produtoId)) this.precosRevisaoRecolhidos.delete(produtoId);
    else this.precosRevisaoRecolhidos.add(produtoId);
  }

  alterePrecoRevisao(preco: PrecoConfirmacaoCanalVendaVM, valor: number | null): void {
    this.precosRevisao[this.chavePrecoRevisao(preco)] = valor;
    this.confirmacaoPrecosToken = null;
  }

  async confirmePrecosRevisao(): Promise<void> {
    if(!this.previaLote?.confirmacaoPrecosToken || !this.canalSelecionadoId ||
      !this.precosRevisaoValidos || this.salvandoPrecosRevisao || this.publicando ||
      this.revisaoDesatualizada) return;
    const canalId = this.canalSelecionadoId;
    const geracao = this.geracaoCanal;
    const previa = this.previaLote;
    this.salvandoPrecosRevisao = true;
    try {
      const resultado = await this.facade.confirmePrecosPrevia(canalId, {
        produtoIds: this.produtoIdsSelecionadosParaPublicacao(),
        recursoIds: Array.from(this.recursosSelecionados),
        confirmacaoPrecosToken: previa.confirmacaoPrecosToken,
        precos: previa.precosAConfirmar.map(preco => ({
          tipo: preco.tipo, alvoId: preco.alvoId,
          valor: this.precosRevisao[this.chavePrecoRevisao(preco)] as number
        }))
      });
      if(this.destruido || canalId !== this.canalSelecionadoId || geracao !== this.geracaoCanal ||
        previa !== this.previaLote) return;
      this.previaLote = resultado.previa;
      this.prepareComparacoesRevisao();
      if(resultado.confirmado) {
        this.confirmacaoPrecosToken = resultado.previa.confirmacaoPrecosToken;
        this.notificacao.showSuccess('Preços salvos na tabela do canal. Nenhum item foi publicado ainda.');
      } else this.notificacao.showWarning('Os preços mudaram durante a gravação. Revise os valores novamente.');
    } catch(erro) {
      if(!this.destruido && canalId === this.canalSelecionadoId && geracao === this.geracaoCanal) {
        if(erro instanceof ErroHttpCanalVenda && erro.status === 409)
          this.revisaoDesatualizada = true;
        this.trateErro(erro, 'Não foi possível salvar os preços na tabela do canal. Nada foi publicado.');
      }
    } finally {
      this.salvandoPrecosRevisao = false;
    }
  }

  private monteComparacaoRevisao(item: PreviaProdutoCanalVendaVM): void {
    const categorias: {[id: string]: string} = {};
    this.categoriasExternas.forEach(categoria => categorias[categoria.id] = categoria.nome);
    this.comparacoesRevisao[item.produtoId] = {
      completas: linhasRevisao(item, true, categorias),
      grupos: gruposRevisao(item)
    };
  }

  alterneGrupoRevisao(produtoId: number, chaveGrupo: string): void {
    const chave = `${produtoId}:${chaveGrupo}`;
    if(this.gruposRevisaoRecolhidos.has(chave)) this.gruposRevisaoRecolhidos.delete(chave);
    else this.gruposRevisaoRecolhidos.add(chave);
  }

  async alterneDetalhesRevisao(item: PreviaProdutoCanalVendaVM): Promise<void> {
    if(this.detalhesRevisao.has(item.produtoId)) this.detalhesRevisao.delete(item.produtoId);
    else {
      this.detalhesRevisao.add(item.produtoId);
      await this.carregueDetalhesRevisao(item);
    }
  }

  async carregueDetalhesRevisao(item: PreviaProdutoCanalVendaVM): Promise<void> {
    if(this.comparacoesRevisao[item.produtoId] || this.carregandoDetalhesRevisao.has(item.produtoId) ||
      !this.canalSelecionadoId || this.publicando || this.revisaoDesatualizada) return;
    const lote = this.previaLote;
    const canalId = this.canalSelecionadoId;
    const geracao = this.geracaoCanal;
    const carregando = this.carregandoDetalhesRevisao;
    carregando.add(item.produtoId);
    delete this.errosDetalhesRevisao[item.produtoId];
    try {
      const produto = this.produtosCarregados[item.produtoId];
      const resposta = await this.facade.gerePrevia(canalId, {
        produtoIds: this.produtoPrecisaPublicar(produto) ? [item.produtoId] : [],
        recursoIds: produto?.recursoIds || [],
        incluirSnapshot: true
      });
      if(this.destruido || this.previaLote !== lote || geracao !== this.geracaoCanal || !this.revisaoAberta) return;
      const detalhe = resposta.itens[0];
      if(!detalhe) throw new Error('Prévia não retornada.');
      if(detalhe.versao !== item.versao || detalhe.operacao !== item.operacao ||
          detalhe.publicavel !== item.publicavel || JSON.stringify(detalhe.diferencas) !== JSON.stringify(item.diferencas)) {
        this.revisaoDesatualizada = true;
        return;
      }
      item.desejado = detalhe.desejado;
      item.publicado = detalhe.publicado;
      this.monteComparacaoRevisao(item);
    } catch(erro) {
      if(this.previaLote === lote && geracao === this.geracaoCanal && !this.destruido)
        this.errosDetalhesRevisao[item.produtoId] = 'Não foi possível carregar a comparação deste produto.';
    } finally {
      carregando.delete(item.produtoId);
    }
  }

  bloqueiosCadastro(item: PreviaProdutoCanalVendaVM) {
    return (item.bloqueios || []).filter(bloqueio => bloqueio.codigo !== 'CATEGORIA_NAO_MAPEADA');
  }

  produtoDaPrevia(produtoId: number): ProdutoCatalogoCanalVendaVM | null {
    return this.produtosCarregados[produtoId] || null;
  }

  async carregueCategoriasExternas(): Promise<void> {
    if(!this.canalSelecionadoId || this.categoriasExternasCarregando) return;
    const canalId = this.canalSelecionadoId;
    const geracao = this.geracaoCanal;
    const previa = this.previaLote;
    const consultaAtual = () => !this.destruido && canalId === this.canalSelecionadoId && geracao === this.geracaoCanal;
    this.categoriasExternasCarregando = true;
    this.categoriasExternasErro = '';
    this.categoriasExternas = [];
    try {
      const categorias = await this.facade.listeCategoriasExternas(canalId);
      if(!consultaAtual()) return;
      if(!Array.isArray(categorias)) throw new Error(`Resposta de categorias do ${this.nomePlataforma} inválida.`);
      this.categoriasExternas = categorias;
      if(!categorias.length && this.canalSelecionado?.plataforma === 'FOOD99' &&
        this.revisaoAberta && previa && previa === this.previaLote) {
        const categoriaIds = new Set(previa.itens.filter(item => this.categoriaPendente(item))
          .map(item => this.produtoDaPrevia(item.produtoId)?.categoria?.id).filter(id => !!id));
        for(const categoriaId of categoriaIds) {
          if(!consultaAtual() || !this.revisaoAberta || previa !== this.previaLote) return;
          await this.facade.resolvaCategoria(canalId, categoriaId, {modo: 'CRIAR'});
        }
        if(!categoriaIds.size || !consultaAtual() || !this.revisaoAberta || previa !== this.previaLote) return;
        const atualizada = await this.facade.gerePrevia(canalId, {
          produtoIds: this.produtoIdsSelecionadosParaPublicacao(),
          recursoIds: Array.from(this.recursosSelecionados),
          incluirSnapshot: this.selecionados.size <= 20
        });
        if(!consultaAtual() || !this.revisaoAberta || previa !== this.previaLote) return;
        this.previaLote = atualizada;
        this.prepareComparacoesRevisao();
      }
    } catch(erro) {
      if(!consultaAtual()) return;
      this.categoriasExternasErro = erro && typeof erro.message === 'string' ? erro.message :
        `Não foi possível consultar as categorias do ${this.nomePlataforma}.`;
      this.trateErro(erro, `Não foi possível consultar as categorias do ${this.nomePlataforma}.`);
    } finally {
      this.categoriasExternasCarregando = false;
    }
  }

  async resolvaCategoriaPrevia(
    item: PreviaProdutoCanalVendaVM, modo: 'CRIAR' | 'EXISTENTE'
  ): Promise<void> {
    if(!this.canalSelecionadoId) return;
    const produto = this.produtoDaPrevia(item.produtoId);
    const categoriaId = produto?.categoria?.id;
    if(!categoriaId) {
      this.notificacao.showWarning('O produto não possui categoria local.');
      return;
    }
    const categoriaExternaId = this.categoriasExternasSelecionadas[categoriaId];
    if(modo === 'EXISTENTE' && !categoriaExternaId) {
      this.notificacao.showWarning(`Selecione uma categoria existente no ${this.nomePlataforma}.`);
      return;
    }
    this.categoriasResolvendo.add(categoriaId);
    try {
      await this.facade.resolvaCategoria(this.canalSelecionadoId, categoriaId, {
        modo, categoriaExternaId: modo === 'EXISTENTE' ? categoriaExternaId : undefined
      });
      this.previaLote = await this.facade.gerePrevia(this.canalSelecionadoId, {
        produtoIds: this.produtoIdsSelecionadosParaPublicacao(),
        recursoIds: Array.from(this.recursosSelecionados),
        incluirSnapshot: this.selecionados.size <= 20
      });
      this.prepareComparacoesRevisao();
      this.notificacao.showSuccess(modo === 'CRIAR'
        ? this.canalSelecionado?.plataforma === 'FOOD99' ? 'Categoria preparada para criar junto à publicação do menu.'
          : `Categoria criada no ${this.nomePlataforma} e associada.` : `Categoria do ${this.nomePlataforma} associada.`);
    } catch(erro) {
      this.trateErro(erro, 'Não foi possível resolver a categoria da publicação.');
    } finally {
      this.categoriasResolvendo.delete(categoriaId);
    }
  }

  async confirmePublicacao(): Promise<void> {
    if(this.publicando || this.salvandoPrecosRevisao || !this.canalSelecionadoId || !this.previaLote ||
      (!this.idsPublicaveis.length && !this.idsRecursosPublicaveis.length) ||
      this.revisaoDesatualizada || !this.precosDaRevisaoConfirmados ||
      this.carregandoDetalhesRevisao.size || this.categoriasExternasCarregando ||
      this.categoriasResolvendo.size) return;
    this.publicando = true;
    this.avisoRuntime = '';
    this.erroRevisao = '';
    try {
      const lote = await this.facade.crieLote(
        this.canalSelecionadoId,
        this.idsPublicaveis.filter(id => this.produtoIdsSelecionadosParaPublicacao().includes(id)),
        this.confirmacaoPrecosToken,
        this.idsRecursosPublicaveis
      );
      this.selecionados = new Set<number>();
      this.recursosSelecionados = new Set<number>();
      this.previaLote = null;
      this.publicacaoId = lote.publicacaoId;
      this.revisaoAberta = false;
      this.notificacao.showSuccess('Publicação recebida e colocada em processamento.');
      await this.carreguePublicacoes();
      this.abraPublicacao(lote.publicacaoId);
      await this.router.navigate([], {relativeTo: this.route, replaceUrl: true,
        queryParams: {canalId: this.canalSelecionadoId, publicacaoId: lote.publicacaoId},
        queryParamsHandling: 'merge'});
    } catch(erro) {
      if(erro instanceof ErroHttpCanalVenda && erro.status === 503) {
        this.avisoRuntime = 'A publicação está temporariamente indisponível. Nenhum lote foi criado.';
        this.cancelePoll();
      }
      this.trateErro(erro, 'Não foi possível criar o lote de publicação.');
    } finally {
      this.publicando = false;
    }
  }

  get recursosCancelaveisSelecionados(): Array<{recursoId: number; versao: number}> {
    const recursos = new Map<number, number>();
    this.itensSelecionadosCarregados().forEach(item =>
      (item.alteracoesCompartilhadas || []).forEach(adicional =>
        (adicional.recursosCancelaveis || []).forEach(recurso =>
          recursos.set(recurso.recursoId, recurso.versao))));
    return Array.from(recursos, ([recursoId, versao]) => ({recursoId, versao}));
  }

  abraDescartePendencias(): void {
    if(this.publicando || this.descartandoPendencias || !this.recursosCancelaveisSelecionados.length) return;
    this.focoAnteriorCancelamentoPendencias = document.activeElement as HTMLElement;
    this.recursosParaCancelar = this.recursosCancelaveisSelecionados;
    this.erroDescarte = '';
    this.confirmarDescarte = true;
    setTimeout(() => this.modalCancelamentoPendencias?.nativeElement
      .querySelector<HTMLElement>('[data-voltar-cancelamento]')?.focus({preventScroll: true}));
  }

  fecheDescartePendencias(): void {
    if(this.descartandoPendencias) return;
    this.confirmarDescarte = false;
    this.erroDescarte = '';
    this.recursosParaCancelar = [];
    this.focoAnteriorCancelamentoPendencias?.focus({preventScroll: true});
  }

  teclaCancelamentoPendencias(evento: KeyboardEvent): void {
    if(evento.key === 'Escape') {
      evento.preventDefault();
      this.fecheDescartePendencias();
    }
    if(evento.key !== 'Tab') return;
    const botoes = this.modalCancelamentoPendencias?.nativeElement
      .querySelectorAll<HTMLElement>('button:not([disabled])');
    if(!botoes?.length) { evento.preventDefault(); return; }
    if(evento.shiftKey && document.activeElement === botoes[0]) {
      evento.preventDefault(); botoes[botoes.length - 1].focus();
    } else if(!evento.shiftKey && document.activeElement === botoes[botoes.length - 1]) {
      evento.preventDefault(); botoes[0].focus();
    }
  }

  async descartePendencias(): Promise<void> {
    if(!this.confirmarDescarte || this.descartandoPendencias || !this.canalSelecionadoId ||
        !this.recursosParaCancelar.length) return;
    const canalId = this.canalSelecionadoId;
    const geracao = this.geracaoCanal;
    this.descartandoPendencias = true;
    this.erroDescarte = '';
    try {
      const resultado = await this.facade.cancelePendenciasRecursos(canalId, {
        recursos: this.recursosParaCancelar
      });
      if(this.destruido || canalId !== this.canalSelecionadoId || geracao !== this.geracaoCanal) return;
      this.confirmarDescarte = false;
      this.recursosParaCancelar = [];
      this.focoAnteriorCancelamentoPendencias?.focus({preventScroll: true});
      this.previaLote = null;
      this.selecionados = new Set<number>();
      this.recursosSelecionados = new Set<number>();
      this.notificacao.showSuccess(`${resultado.adicionaisCancelados} pendência(s) de adicional cancelada(s).`);
      await this.carregueCatalogo();
    } catch(erro) {
      if(this.destruido || canalId !== this.canalSelecionadoId || geracao !== this.geracaoCanal) return;
      this.erroDescarte = erro instanceof Error ? erro.message :
        'Não foi possível cancelar as pendências. Atualize a página e tente novamente.';
    } finally {
      this.descartandoPendencias = false;
    }
  }

  retomeAcompanhamento(): void {
    if(this.atualizandoAndamento || !this.publicacaoId || !this.canalSelecionadoId) return;
    this.iniciePoll();
  }

  async carreguePublicacoes(): Promise<void> {
    const canalId = this.canalSelecionadoId;
    if(!canalId) return;
    try {
      const publicacoes = await this.facade.listePublicacoes(canalId);
      if(this.destruido || canalId !== this.canalSelecionadoId) return;
      this.publicacoes = publicacoes;
      if(this.aba === 'PROCESSANDO' && !this.publicacaoId && publicacoes.length)
        this.abraPublicacao(publicacoes[0].id);
    } catch(erro) {
      this.trateErro(erro, 'Não foi possível carregar as publicações do canal.');
    }
  }

  abraPublicacao(publicacaoId: number): void {
    this.publicacaoId = publicacaoId;
    this.publicacao = null;
    this.aba = 'PROCESSANDO';
    this.iniciePoll();
  }

  async abraHistorico(item: ProdutoCatalogoCanalVendaVM): Promise<void> {
    if(!this.canalSelecionadoId) return;
    this.focoAnteriorHistorico = document.activeElement instanceof HTMLElement
      ? document.activeElement : null;
    this.produtoHistorico = item;
    this.historico = null;
    this.erroHistorico = '';
    setTimeout(() => this.drawerHistorico?.nativeElement.focus({preventScroll: true}));
    await this.carregueHistorico();
  }

  async carregueHistorico(): Promise<void> {
    const item = this.produtoHistorico;
    const canalVendaId = this.canalSelecionadoId;
    if(!item || !canalVendaId) return;
    const geracao = ++this.geracaoHistorico;
    this.carregandoHistorico = true;
    this.erroHistorico = '';
    try {
      const historico = await this.facade.listeHistorico(canalVendaId, item.produtoId, 50);
      if(!this.destruido && geracao === this.geracaoHistorico &&
          canalVendaId === this.canalSelecionadoId && item.produtoId === this.produtoHistorico?.produtoId)
        this.historico = historico;
    } catch(erro) {
      if(!this.destruido && geracao === this.geracaoHistorico)
        this.erroHistorico = erro instanceof Error && erro.message ? erro.message :
          'Não foi possível carregar o histórico deste produto.';
    } finally {
      if(geracao === this.geracaoHistorico) this.carregandoHistorico = false;
    }
  }

  fecheHistorico(): void {
    this.geracaoHistorico++;
    this.produtoHistorico = null;
    this.historico = null;
    this.erroHistorico = '';
    this.carregandoHistorico = false;
    setTimeout(() => this.focoAnteriorHistorico?.focus({preventScroll: true}));
  }

  teclaHistorico(evento: KeyboardEvent): void {
    if(evento.key !== 'Escape') return;
    evento.preventDefault();
    evento.stopPropagation();
    this.fecheHistorico();
  }

  imagemProdutoHistorico(): string {
    return imagemRevisao(this.produtoHistorico?.imagem);
  }

  rotuloSituacaoHistorico(situacao: string): string {
    switch(situacao) {
      case 'SUCESSO': return 'Concluído';
      case 'ERRO': return 'Com erro';
      case 'CANCELADO': return 'Cancelado';
      case 'PROCESSANDO': return 'Em processamento';
      case 'PENDENTE': return 'Aguardando';
      default: return situacao;
    }
  }

  async reenvieItem(itemId: number): Promise<void> {
    const item = this.publicacao?.itens.find(atual => atual.id === itemId);
    if(!item?.reenvioPermitido || !this.publicacaoId || !this.canalSelecionadoId) return;
    await this.reenvieFalha(this.publicacaoId, itemId);
  }

  async reenvieProduto(item: ProdutoCatalogoCanalVendaVM): Promise<void> {
    const envio = item.ultimoEnvio;
    if(!envio?.reenvioPermitido || !envio.itemId || item.situacaoPublicacao !== 'ERRO') return;
    await this.reenvieFalha(envio.publicacaoId, envio.itemId);
  }

  private async reenvieFalha(publicacaoId: number, itemId: number): Promise<void> {
    if(!this.canalSelecionado?.ativo || this.reenviandoItemId !== null ||
      this.publicando || this.aplicandoMassa || this.temSalvamento) return;
    const canalId = this.canalSelecionadoId;
    const geracao = this.geracaoCanal;
    this.reenviandoItemId = itemId;
    try {
      const novo = await this.facade.reenvieFalha(canalId, publicacaoId, itemId);
      if(this.destruido || canalId !== this.canalSelecionadoId || geracao !== this.geracaoCanal) return;
      this.notificacao.showSuccess('Novo lote criado para a falha selecionada.');
      await this.carregueCatalogo();
      await this.carreguePublicacoes();
      if(!this.destruido && canalId === this.canalSelecionadoId && geracao === this.geracaoCanal)
        this.abraPublicacao(novo.publicacaoId);
    } catch(erro) {
      if(!this.destruido && canalId === this.canalSelecionadoId && geracao === this.geracaoCanal)
        this.trateErro(erro, 'Não foi possível reenviar este item.');
    } finally {
      this.reenviandoItemId = null;
    }
  }

  async ativeCanal(): Promise<void> {
    if(!this.canalSelecionadoId) return;
    try {
      await this.facade.ativeCanal(this.canalSelecionadoId);
      await this.recarregueCanais();
      this.notificacao.showSuccess('Canal ativado.');
      await this.carregueCatalogo();
    } catch(erro) {
      this.trateErro(erro, 'Não foi possível ativar o canal.');
    }
  }

  async desativeCanal(): Promise<void> {
    if(this.desativandoCanal || !this.confirmarDesativacao || !this.canalSelecionadoId) return;
    this.desativandoCanal = true;
    try {
      await this.facade.desativeCanal(this.canalSelecionadoId);
      this.cancelePoll();
      await this.recarregueCanais();
      this.confirmarDesativacao = false;
      this.notificacao.showSuccess('Canal desativado.');
    } catch(erro) {
      this.trateErro(erro, 'Não foi possível desativar o canal.');
    } finally {
      this.desativandoCanal = false;
    }
  }

  abraRemocaoCanal(): void {
    if(!this.canalSelecionadoId || this.desativandoCanal) return;
    this.focoAnteriorRemocaoCanal = document.activeElement as HTMLElement;
    this.erroRemocaoCanal = '';
    this.confirmarDesativacao = false;
    this.confirmarRemocao = true;
    setTimeout(() => {
      if(this.destruido) return;
      this.modalRemocaoCanal?.nativeElement.querySelector<HTMLElement>('[data-cancelar-remocao]')
        ?.focus({preventScroll: true});
    });
  }

  fecheRemocaoCanal(): void {
    if(this.desativandoCanal) return;
    this.confirmarRemocao = false;
    this.focoAnteriorRemocaoCanal?.focus({preventScroll: true});
  }

  teclaRemocaoCanal(evento: KeyboardEvent): void {
    if(evento.key === 'Escape') {
      evento.preventDefault();
      evento.stopPropagation();
      this.fecheRemocaoCanal();
    }
    if(evento.key !== 'Tab') return;
    const elementos = this.modalRemocaoCanal?.nativeElement.querySelectorAll<HTMLElement>('button:not([disabled])');
    if(!elementos?.length) { evento.preventDefault(); return; }
    const primeiro = elementos[0];
    const ultimo = elementos[elementos.length - 1];
    if(evento.shiftKey && document.activeElement === primeiro) {
      evento.preventDefault(); ultimo.focus();
    } else if(!evento.shiftKey && document.activeElement === ultimo) {
      evento.preventDefault(); primeiro.focus();
    }
  }

  async removaCanal(): Promise<void> {
    if(this.desativandoCanal || !this.confirmarRemocao || !this.canalSelecionadoId ||
        this.publicando || this.temSalvamento || this.aplicandoMassa || this.vinculandoExistentes) return;
    this.desativandoCanal = true;
    this.erroRemocaoCanal = '';
    try {
      await this.facade.removaCanal(this.canalSelecionadoId);
      this.confirmarRemocao = false;
      this.focoAnteriorRemocaoCanal?.focus({preventScroll: true});
      await this.selecioneCanal(null);
      await this.recarregueCanais();
      this.abraNovoCanal();
      this.notificacao.showSuccess(`Canal removido. Nenhum produto foi removido do ${this.nomePlataforma}.`);
    } catch(erro) {
      if(this.confirmarRemocao)
        this.erroRemocaoCanal = erro instanceof Error && erro.message ? erro.message :
          'Não foi possível remover o canal.';
      else this.trateErro(erro, 'O canal foi removido, mas não foi possível atualizar a tela.');
    } finally {
      this.desativandoCanal = false;
    }
  }

  rotuloSituacaoProduto(situacao: string): string {
    switch(situacao) {
      case 'SUCESSO': case 'PUBLICADO': return 'Publicado';
      case 'ERRO': return 'Com erro';
      case 'BLOQUEADO': return 'Com bloqueio';
      case 'PUBLICANDO': case 'PROCESSANDO': return 'Em processamento';
      case 'PENDENTE': return 'Pendente de revisão';
      default: return 'Não configurado';
    }
  }

  async abraUltimoEnvio(item: ProdutoCatalogoCanalVendaVM): Promise<void> {
    if(!item.ultimoEnvio) return;
    await this.carreguePublicacoes();
    this.abraPublicacao(item.ultimoEnvio.publicacaoId);
  }

  abraNovoCanal(): void {
    this.focoAnteriorNovoCanal = document.activeElement as HTMLElement;
    this.mostrarNovoCanal = true;
    this.precoIgualNovoCanal = true;
    this.percentualNovoCanal = null;
    setTimeout(() => {
      if(this.destruido) return;
      const formulario = this.formularioNovoCanal?.nativeElement;
      formulario?.querySelector('select')?.focus({preventScroll: true});
    });
  }

  fecheNovoCanal(): void {
    if(this.salvandoCanal) return;
    this.mostrarNovoCanal = false;
    this.focoAnteriorNovoCanal?.focus({preventScroll: true});
  }

  teclaNovoCanal(evento: KeyboardEvent): void {
    if(evento.key === 'Escape') {
      evento.preventDefault();
      evento.stopPropagation();
      this.fecheNovoCanal();
    }
    if(evento.key !== 'Tab') return;
    const elementos = this.formularioNovoCanal?.nativeElement.querySelectorAll<HTMLElement>(
      'button:not([disabled]), input:not([disabled]), select:not([disabled])');
    if(!elementos?.length) { evento.preventDefault(); return; }
    const primeiro = elementos[0];
    const ultimo = elementos[elementos.length - 1];
    if(evento.shiftKey && document.activeElement === primeiro) {
      evento.preventDefault(); ultimo.focus();
    } else if(!evento.shiftKey && document.activeElement === ultimo) {
      evento.preventDefault(); primeiro.focus();
    }
  }

  async crieCanal(): Promise<void> {
    if(this.salvandoCanal) return;
    this.erroNovoCanal = '';
    const destino = this.destinoSelecionadoNovoCanal();
    const percentual = this.precoIgualNovoCanal ? null : Number(this.percentualNovoCanal);
    if(!this.precoIgualNovoCanal && (this.percentualNovoCanal == null ||
        String(this.percentualNovoCanal).trim() === '' || !Number.isFinite(percentual) ||
        percentual < -100 || percentual > 1000)) {
      this.erroNovoCanal = 'Informe um percentual entre -100% e 1000%.';
      return;
    }
    if(!destino || !this.nomeNovoCanal.trim() || !this.catalogoExternoNovoCanal.trim() ||
        this.carregandoCatalogosNovoCanal) {
      this.erroNovoCanal = !destino ? 'Selecione a integração autorizada.' :
        this.carregandoCatalogosNovoCanal ? 'Aguarde o carregamento dos catálogos.' :
        this.catalogoNovoCanalSemIdentificador ? this.avisoCatalogoSemIdentificador :
        !this.catalogoExternoNovoCanal.trim() ? 'Informe o catálogo.' : 'Informe o nome do canal.';
      return;
    }
    this.salvandoCanal = true;
    try {
      const criado = await this.facade.crieCanal({
        nome: this.nomeNovoCanal.trim(),
        plataforma: destino.plataforma || 'IFOOD',
        integracaoId: destino.id,
        merchantId: destino.merchantId,
        catalogoExternoId: this.catalogoExternoNovoCanal.trim(),
        percentualPrecoPadrao: percentual
      });
      await this.facade.ativeCanal(criado.id);
      await this.recarregueCanais();
      this.mostrarNovoCanal = false;
      await this.selecioneCanal(criado.id);
      await this.router.navigate([], {relativeTo: this.route, queryParamsHandling: 'merge',
        queryParams: {canalId: criado.id, vincular: 'true', publicacaoId: null}});
    } catch(erro) {
      this.mostrarNovoCanal = true;
      this.erroNovoCanal = erro instanceof Error && erro.message ? erro.message :
        'Não foi possível criar e ativar o canal.';
    } finally {
      this.salvandoCanal = false;
    }
  }

  abraConfiguracaoPrecoCanal(): void {
    const percentual = this.canalSelecionado?.percentualPrecoPadrao;
    this.precoIgualCanal = percentual == null;
    this.percentualCanal = percentual;
    this.erroPrecoCanal = '';
    this.configurandoPrecoCanal = true;
  }

  fecheConfiguracaoPrecoCanal(): void {
    if(this.salvandoPrecoCanal) return;
    this.configurandoPrecoCanal = false;
    this.erroPrecoCanal = '';
  }

  async salveConfiguracaoPrecoCanal(): Promise<void> {
    if(!this.canalSelecionadoId || this.salvandoPrecoCanal) return;
    const percentual = this.precoIgualCanal ? null : Number(this.percentualCanal);
    if(!this.precoIgualCanal && (this.percentualCanal == null || String(this.percentualCanal).trim() === '' ||
        !Number.isFinite(percentual) || percentual < -100 || percentual > 1000)) {
      this.erroPrecoCanal = 'Informe um percentual entre -100% e 1000%.';
      return;
    }
    this.salvandoPrecoCanal = true;
    this.erroPrecoCanal = '';
    try {
      const resultado = await this.facade.configurePrecoCanal(this.canalSelecionadoId, percentual);
      this.canais = this.canais.map(canal => canal.id === resultado.canal.id ? resultado.canal : canal);
      if(this.destinos) this.destinos.canais = this.canais;
      this.configurandoPrecoCanal = false;
      await this.carregueCatalogo();
      this.notificacao.showSuccess(resultado.produtosImpactados
        ? `Regra salva. ${resultado.produtosImpactados} produto(s) precisam de revisão.`
        : 'Regra de preços salva.');
    } catch(erro) {
      this.erroPrecoCanal = erro instanceof Error && erro.message
        ? erro.message : 'Não foi possível salvar a regra de preços.';
    } finally {
      this.salvandoPrecoCanal = false;
    }
  }

  get catalogoNovoCanalSemIdentificador(): boolean {
    return this.catalogosNovoCanal.length > 0 && !this.catalogoExternoNovoCanal.trim();
  }

  get avisoCatalogoSemIdentificador(): string {
    return this.destinoSelecionadoNovoCanal()?.plataforma === 'FOOD99'
      ? 'O catálogo está sem ID externo. Para configurar o canal, preencha na 99Food: “Extra ID” no catálogo, “ID externo da categoria” nas categorias e “Código PDV” nos produtos.'
      : 'O catálogo foi encontrado, mas a integração não retornou seu identificador. Esse identificador é necessário para criar e ativar o canal.';
  }

  async selecioneDestinoNovoCanal(valor: any): Promise<void> {
    this.erroNovoCanal = '';
    this.destinoNovoCanalId = valor == null || valor === '' ? null : String(valor);
    this.catalogosNovoCanal = [];
    this.catalogoExternoNovoCanal = '';
    const destino = this.destinoSelecionadoNovoCanal();
    if(!destino) return;
    this.carregandoCatalogosNovoCanal = true;
    try {
      const catalogos: any[] = destino.plataforma === 'FOOD99'
        ? await this.facade.listeMenusFood99(destino.id)
        : await this.importadorIfood.listeCatalogosIfoodOficial(destino.merchantId);
      this.catalogosNovoCanal = (catalogos || [])
        .map(catalogo => ({
          id: String(catalogo?.catalogId || catalogo?.id || '').trim(),
          nome: String(catalogo?.nome || catalogo?.name || catalogo?.type || catalogo?.context ||
            catalogo?.catalogId || catalogo?.id || 'Catálogo').trim()
        }));
      if(this.catalogosNovoCanal.length)
        this.catalogoExternoNovoCanal = this.catalogosNovoCanal[0].id;
      else
        this.erroNovoCanal = 'Nenhum catálogo foi encontrado para esta integração.';
    } catch(erro) {
      this.erroNovoCanal = erro instanceof Error && erro.message ? erro.message :
        'Não foi possível carregar os catálogos da integração.';
    } finally {
      this.carregandoCatalogosNovoCanal = false;
    }
  }

  corrijaProduto(produtoId: number): void {
    void this.router.navigate(['/admin/produtos-v2'], {
      queryParams: {produtoDrawer: produtoId}
    });
  }

  trackProduto(_indice: number, item: ProdutoCatalogoCanalVendaVM): number {
    return item.produtoId;
  }

  trackGrupo(_indice: number, item: any): string {
    return item.externalCode;
  }

  quantidadeAlteracoes(previa: PreviaProdutoCanalVendaVM): number {
    return this.diferencasVisiveis(previa).length;
  }

  diferencasVisiveis(previa: PreviaProdutoCanalVendaVM): PreviaProdutoCanalVendaVM['diferencas'] {
    return (previa.diferencas || []).filter(diferenca => diferenca.caminho !== 'comercial.vender');
  }

  rotuloDiferenca(caminho: string): string {
    return rotuloCaminhoDiferenca(caminho);
  }

  valorDiferenca(valor: any): string {
    if(valor === null || valor === undefined || valor === '') return '—';
    if(typeof valor === 'boolean') return valor ? 'Ativo' : 'Pausado';
    if(typeof valor === 'number') return valor.toLocaleString('pt-BR', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    });
    if(typeof valor === 'object')
      return valor.quantidade != null ? `${valor.quantidade} item(ns)` : 'Alterado';
    return String(valor);
  }

  private async recarregueCanais(): Promise<void> {
    this.canais = await this.facade.listeCanais();
  }

  private crieEdicao(item: ProdutoCatalogoCanalVendaVM): EdicaoProdutoCanalVenda {
    return {
      disponivel: item.disponivel,
      salvando: false
    };
  }

  private invalideConsultasCatalogo(limpeDetalhes = false): void {
    this.geracaoCatalogo++;
    this.geracaoContexto++;
    this.requisicoesPrevia = {};
    this.carregandoPrevia = new Set<number>();
    if(limpeDetalhes) {
      this.previas = {};
      this.expandidos = new Set<number>();
    }
  }

  private consultaCatalogoAtual(
    geracaoCanal: number,
    geracaoCatalogo: number,
    canalVendaId: number
  ): boolean {
    return !this.destruido && geracaoCanal === this.geracaoCanal &&
      geracaoCatalogo === this.geracaoCatalogo && canalVendaId === this.canalSelecionadoId;
  }

  private consultaPreviaAtual(
    produtoId: number,
    geracaoPrevia: number,
    geracaoCanal: number,
    geracaoContexto: number,
    canalVendaId: number
  ): boolean {
    return !this.destruido && this.requisicoesPrevia[produtoId] === geracaoPrevia &&
      geracaoCanal === this.geracaoCanal && geracaoContexto === this.geracaoContexto &&
      canalVendaId === this.canalSelecionadoId;
  }

  private itensSelecionadosCarregados(): ProdutoCatalogoCanalVendaVM[] {
    return Array.from(this.selecionados).map(id => this.produtosCarregados[id]).filter(Boolean);
  }

  private sincronizeRecursosSelecionados(): void {
    this.recursosSelecionados = new Set(this.itensSelecionadosCarregados().reduce(
      (ids, item) => ids.concat(item.recursoIds || []), [] as number[]
    ));
  }

  private produtoPrecisaPublicar(item: ProdutoCatalogoCanalVendaVM | null): boolean {
    if(!item) return false;
    return item.vinculo === 'SEM_VINCULO' || this.temEdicaoPendente(item) ||
      ['PENDENTE', 'ERRO', 'BLOQUEADO'].includes(item.situacaoPublicacao);
  }

  private produtoIdsSelecionadosParaPublicacao(): number[] {
    return this.itensSelecionadosCarregados()
      .filter(item => this.podeSelecionarProduto(item) && this.produtoPrecisaPublicar(item))
      .map(item => item.produtoId);
  }

  private destinoSelecionadoNovoCanal(): DestinoCanalVendaVM | null {
    return this.destinos?.destinos.find(destino =>
      `${destino.plataforma || 'IFOOD'}:${destino.id}` === this.destinoNovoCanalId) || null;
  }

  private iniciePoll(): void {
    this.cancelePoll();
    this.pollQuantidade = 0;
    const geracao = ++this.pollGeracao;
    void this.executePoll(geracao, true);
  }

  private agendePoll(geracao: number, atraso: number): void {
    this.pollTimer = setTimeout(() => void this.executePoll(geracao), atraso);
  }

  private async executePoll(geracao: number, consultaManual = false): Promise<void> {
    if(this.destruido || geracao !== this.pollGeracao ||
        !this.canalSelecionadoId || !this.publicacaoId) return;
    const canalVendaId = Number(this.canalSelecionadoId);
    const publicacaoId = Number(this.publicacaoId);
    this.atualizandoAndamento = consultaManual;
    try {
      const publicacao = await this.facade.acompanheLote(canalVendaId, publicacaoId);
      if(this.destruido || geracao !== this.pollGeracao ||
          canalVendaId !== this.canalSelecionadoId || publicacaoId !== this.publicacaoId) return;
      this.publicacao = publicacao;
      this.erroConsultaAndamento = false;
      this.ultimaConsultaAndamento = new Date();
      this.resultadoConsultaAndamento = `Resultado atualizado. ` +
        `${this.rotuloSituacaoLote(publicacao.situacao)}: ${publicacao.quantidadeSucessos} concluído(s), ` +
        `${publicacao.quantidadeErros} com erro, ${publicacao.quantidadeCancelados || 0} cancelado(s), de ${publicacao.quantidadeItens} produto(s).`;
      this.publicacoes = this.publicacoes.map(lote => lote.id === publicacao.id
        ? {...lote, situacao: publicacao.situacao, quantidadeSucessos: publicacao.quantidadeSucessos,
          quantidadeErros: publicacao.quantidadeErros, quantidadeCancelados: publicacao.quantidadeCancelados} : lote);
      this.pollQuantidade++;
      if(this.acompanhamentoTerminal) {
        this.cancelePoll(false);
        await this.carregueCatalogo();
        await this.carreguePublicacoes();
        return;
      }
      if(this.pollQuantidade >= this.limitePoll) {
        this.cancelePoll(false);
        this.notificacao.showInfo('Acompanhamento pausado. Atualize manualmente para continuar.');
        return;
      }
      this.agendePoll(geracao, 3000);
    } catch(erro) {
      if(this.destruido || geracao !== this.pollGeracao ||
          canalVendaId !== this.canalSelecionadoId || publicacaoId !== this.publicacaoId) return;
      this.cancelePoll(false);
      this.erroConsultaAndamento = true;
      this.resultadoConsultaAndamento = 'Não foi possível consultar o andamento. Tente novamente.';
      this.trateErro(erro, 'Não foi possível atualizar o andamento do lote.');
    } finally {
      if(geracao === this.pollGeracao) this.atualizandoAndamento = false;
    }
  }

  private cancelePoll(invalide = true): void {
    if(this.pollTimer) clearTimeout(this.pollTimer);
    this.pollTimer = null;
    if(invalide) {
      this.pollGeracao++;
      this.atualizandoAndamento = false;
      this.ultimaConsultaAndamento = null;
      this.resultadoConsultaAndamento = '';
      this.erroConsultaAndamento = false;
    }
  }

  private trateErro(erro: any, padrao: string): void {
    const mensagem = erro instanceof Error && erro.message ? erro.message : padrao;
    this.erro = mensagem || padrao;
    if(this.revisaoAberta) this.erroRevisao = this.erro;
    this.notificacao.showError(this.erro);
  }
}
